import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "react-dual-listbox/lib/react-dual-listbox.css";
import { Field, FieldArray, Form, FormikProvider, useFormik } from "formik";
import { addCategoryValidator } from "utils/validator";
import {
  getAreaList,
  getCollectionTypeList,
  getDoctorList,
  getStateList,
  getFranchiseTypesList,
  getPaymentModeList,
  getInvestigationList,
  getCollectionBoyList,
  getDeliveryBoyList,
  getEmployeeList,
  getZoneList,
  getBarcode,
  clearBarcode,
  getFranchiseList,
  getFranchisePackageListDD,
} from "../../redux/action/drop_list_action";

import {
  clearNewRegistration,
  deleteNewRegistration,
  deletePackageNewRegistration,
  submitNewRegistration,
} from "../../redux/action/new_registration_actions";
import axiosInstance from "services/axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "context/alert";
import {
  cleartRegistrationSearch,
  submitAppointmentBookingMaster,
  submitRegistrationSearch,
} from "../../redux/action/registration_search_action";
import { FormButton } from "components/Common/Buttons";
import zoneLocalStorageId from "utils/zone";
import { checkNewRegistration } from "services/newRegistration";
import { useQuery } from "@tanstack/react-query";
import { STALE_TIME } from "utils/constants";
import companyLocalStorageId from "utils/companyID";
import RateNotConfiguredModal from "./RateNotConfiguredModal";

const RegistrationFormFormat = ({
  onClose,
  rowData,
  zoneRegistrationData,
  handleDocuments,
  documentInfo,
  setdocumentInfo,
  appointment_id,
  openPackageView,
  isThirdPartyBarcode,
  barcodeDataState,
  setDocmentAppointmentBookingId,
  packageInvestigationData,
  handleBarcodeChange,
  setPackageInvestigationData,
}) => {
  const dispatch = useDispatch();
  const effectRun = useRef(false);

  //.....Search Filter ..........//
  const [oldFilter, setoldFilter] = useState(false);
  const [search_mobile, setsearch_mobile] = useState();
  const [search_appoinment, setsearch_appoinment] = useState();
  const [search_paitent, setsearch_paitent] = useState();
  const [search_city, setsearch_city] = useState();
  const [search_state, setsearch_state] = useState();
  const [search_area, setsearch_area] = useState();
  const [search_dob, setsearch_dob] = useState();
  const [search_from, setsearch_from] = useState();
  const [search_to, setsearch_to] = useState();
  const [search_error, setsearch_error] = useState(false);
  const [patient_id, setpatient_id] = useState();
  const [receptUrl, setreceptUrl] = useState();
  const [investigationval, setinvestigationval] = useState(0);

  const [appointmentId, setappointmentId] = useState();
  const [appointmentDetailId, setappointmentDetailId] = useState();
  const [paymentDetailId, setpaymentDetailId] = useState();
  const [paymentMode, setpaymentMode] = useState();

  const [investigationIds, setInvestigationIds] = useState([]);
  const [packagesIds, setPackagesIds] = useState([]);

  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [showRateNotConfiguredModal, setShowRateNotConfiguredModal] =
    useState(false);

  const [searchText, setSearchText] = useState("");

  const [isDocumentRequired, setIsDocumentRequired] = useState(false);

  const [sampleTypeBarcodeCache, setSampleTypeBarcodeCache] = useState({});

  const [
    isThirdPartyBarcodeInvestigation,
    setIsThirdPartyBarcodeInvestigation,
  ] = useState([]);

  useEffect(() => {
    // console.log("Updated Investigation IDs in useeffect :", investigationIds);
  }, [investigationIds]);

  const deletePayload = {
    appointment_id: Number(appointment_id),
    investigation_ids: investigationIds,
  };

  const deletePackagesPayload = {
    appointment_id: Number(appointment_id),
    package_ids: packagesIds,
  };

  const appointmentBookingData = useSelector(
    (state) => state?.RegistrationSerachReducer?.appointment_booking,
  );

  const [appointmentBookingId, setAppointmentBookingId] = useState(null);

  // Appointment Booking Master API
  // useEffect(() => {
  //   dispatch(submitAppointmentBookingMaster());
  // }, [dispatch]);

  // useEffect(() => {
  //   if (!effectRun.current) {
  //     effectRun.current = true;
  //     dispatch(submitAppointmentBookingMaster());
  //   }
  // }, [dispatch]);

  useEffect(() => {
    if (!effectRun.current && !appointment_id) {
      effectRun.current = true;
      dispatch(submitAppointmentBookingMaster());
    }
  }, [dispatch, appointment_id]);

  useEffect(() => {
    if (appointmentBookingData?.id) {
      setAppointmentBookingId(appointmentBookingData.id);
      setDocmentAppointmentBookingId(appointmentBookingData.id);
    }
  }, [appointmentBookingData]);

  const [searchType, setSearchType] = useState("first");

  //........end..............//
  const navigate = useNavigate();
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const {
    area_list,
    state_list,
    doctor_list,
    collectionType_list,
    franchiseTypes_list,
    payment_mode_list,
    investigation_list,
    collection_boy_list,
    delivery_boy_list,
    employee_list,
    zone_list,
    bar_code_info,
    franchise_list,
    franchise_package_list_dd,
  } = useSelector((state) => state.dropListReducer);

  const _token =
    jwtAuthreducer?.token_values?.sub &&
    JSON.parse(
      jwtAuthreducer?.token_values?.sub
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null"),
    );

  const { new_registration } = useSelector(
    (state) => state.newRegistrationReducer,
  );
  const { registration_serach } = useSelector(
    (state) => state.RegistrationSerachReducer,
  );

  useEffect(() => {
    dispatch(getAreaList());
    dispatch(getStateList());
    dispatch(getDoctorList());
    dispatch(getCollectionTypeList());
    dispatch(getFranchiseTypesList());
    dispatch(getPaymentModeList());
    dispatch(getCollectionBoyList());
    dispatch(getDeliveryBoyList());
    dispatch(getEmployeeList());
    dispatch(getZoneList());
    dispatch(getFranchiseList());
    dispatch(getInvestigationList());
    dispatch(getFranchisePackageListDD());
  }, []);

  const updatedFranchiseId = localStorage.getItem(
    "new_registration_franchise_id",
  );

  useEffect(() => {
    if (!registration_serach?.data?.[0]) return;

    const data = registration_serach.data[0];

    // Mobile number extraction
    const mobile = data.mobile ? data.mobile.split("+91")[1] : "";

    // Booking Id
    setAppointmentBookingId(data?.appointment_booking_id);

    // Set IDs
    setappointmentId(data.appointment_id);
    setappointmentDetailId(data.appointment_detail_id);
    setpaymentDetailId(data.payment_detail_id);

    setFieldValue("company_name", data.franchise_id);

    // Patient details
    setFieldValue("address", data.address);
    setFieldValue("city", data.city);
    setFieldValue("patient_name", data.patient_name);
    setFieldValue("gender", data.gender);
    setFieldValue("date_of_birth", data.dob);
    setFieldValue("mobile", mobile);
    setFieldValue("email", data.email);
    setFieldValue("age.age_year", data.age?.year ?? 0);
    setFieldValue("age.age_month", data.age?.month ?? 0);
    setFieldValue("age.age_day", data.age?.days ?? 0);
    setFieldValue("comments", data.comments);
    setFieldValue("refer_doctor_name", data.refer_doctor_name);
    setpatient_id(data.id);
    setFieldValue("blood_group", {
      label: data.blood_group,
      value: data.blood_group,
    });
    setFieldValue("area", {
      label: data.area_obj?.area_name,
      value: data.area_obj?.id,
    });
    setFieldValue("state", {
      label: data.state_obj?.state,
      value: data.state_obj?.state_id,
    });
    setFieldValue("LMP", Number(data.lmp));
    setFieldValue("height", Number(data.height));
    setFieldValue("weight", data.weight);

    // Doctor details
    setFieldValue("refer_doctor", {
      label: data.refer_doctor_obj?.doctor_name,
      value: data.refer_doctor_obj?.doctor_name,
      doctor_id: data.refer_doctor_obj?.id,
    });
    setFieldValue("collection_type", {
      value: data.collection_type_obj?.id,
      label: data.collection_type_obj?.collection_type,
      collection_type_id: data.collection_type_obj?.id,
    });
    setFieldValue("refer_by_hospital", data.refer_by_hospital);
    setFieldValue("lab_name", data.lab_name);

    // Collection boy details
    const collectionBoy = collection_boy_list?.data?.find(
      (item) => item.employee_code_id === data.collection_boy,
    );
    setFieldValue("collection_boy", {
      value: collectionBoy?.employee_name,
      label: collectionBoy?.employee_name,
      payment_mode_id: collectionBoy?.employee_code_id,
    });

    // Deliver boy details
    const deliverBoy = collection_boy_list?.data?.find(
      (item) => item.employee_code_id === data.deliver_boy,
    );
    setFieldValue("deliver_boy", {
      value: deliverBoy?.employee_name,
      label: deliverBoy?.employee_name,
      payment_mode_id: deliverBoy?.employee_code_id,
    });

    const barcodeCache = {};

    data?.investigation_data?.forEach((item) => {
      if (item.sample_type && item.barcode_no) {
        barcodeCache[item.sample_type] = item.barcode_no;
      }
    });

    // Package investigations से भी cache populate करें
    data?.investigation_data
      ?.filter((item) => item.package_id)
      ?.forEach((item) => {
        if (item.sample_type && item.barcode_no) {
          barcodeCache[item.sample_type] = item.barcode_no;
        }
      });

    // Cache को set करें
    setSampleTypeBarcodeCache(barcodeCache);

    // Investigation details
    const investigtion_detailsinfo = data?.investigation_data
      .filter((item) => !item.package_id)
      .map((item) => ({
        value: item.investigation_name,
        label: item.investigation_name,
        investigation_id: item.investigation_id,
        investigation_name: item.investigation_name,
        investigation_status_obj: item.investigation_status_obj,
        discount: 0,
        rate: 0,
        is_urgent: "0",
        // delivery_time: convertTimestampToDatetimeLocal(item?.delivery_time[0]),
        delivery_time: convertTimestampToDatetimeLocal(
          item?.delivery_time?.[0] ?? null,
        ),
        barcode_id: item?.barcode_no,
        barcode_id_main: item?.barcode_no,
        is_third_party_barcode: false,
        investigation_status_obj: item.investigation_status_obj,
        mrp: item?.mrp,
        rate: item?.rate,
        read_only: true,
        is_active: item.is_active,
        sample_type: item.sample_type,
      }));
    setFieldValue("investigation_name", investigtion_detailsinfo);
    setFieldValue("investigtion_details", investigtion_detailsinfo);
    const package_detailsinfo = data?.investigation_data
      .filter((item) => item.package_id)
      .reduce((acc, item) => {
        let existingPackage = acc.find(
          (pkg) => pkg.package_id === item.package_id,
        );

        let appointmentPackage = data?.appointment_package_data.find(
          (ap) => ap.package_id === item.package_id,
        );

        let investigationData = {
          urgent: item.urgent,
          barcode_obj: {
            barcode_no: item.barcode_no,
          },
          rate: appointmentPackage?.rate || item.rate,
          mrp: appointmentPackage?.mrp || item.mrp,
          discount: item.discount,
          delivery_time: item.delivery_time,
          delivery_days: item.delivery_days,
          generated: item.generated,
          investigation_id: item.investigation_id,
          discount_by: item.discount_by,
          is_active: item.is_active,
          is_third_party_barcode: item.is_third_party_barcode,
          investigation_name: item.investigation_name,
          investigation_status_obj: item.investigation_status_obj,
          container_colour_code: item.container_colour_code,
          lab_department_name: item.lab_department_name,
          sample_type_obj: item.sample_type_obj,
          read_only: true,
        };

        if (existingPackage) {
          existingPackage.package_investigations.push(investigationData);
        } else {
          acc.push({
            package_id: item.package_id,
            package_name: appointmentPackage?.package_obj?.package_name || "",
            mrp: appointmentPackage?.mrp || item.mrp,
            rate: appointmentPackage?.rate || item.rate,
            package_investigations: [investigationData],
            read_only: true,
          });
        }

        return acc;
      }, []);

    const packageIds = [
      ...new Set(package_detailsinfo.map((item) => item.package_id)),
    ];

    setFieldValue("package_details", package_detailsinfo);
    setFieldValue("package_id", packageIds);

    // Discount & charges details
    const paymentmode = payment_mode_list?.data?.find(
      (item) => item.id === data.payment_detail_payment_mode_id,
    );
    setFieldValue("coll_charge", data.collection_charge);
    setFieldValue("adjustment", data.additional_charge);
    setFieldValue("bank_name", data.payment_detail_bank_name);
    setFieldValue("cheque_card_number", data.payment_detail_cheque_or_card_no);
    setFieldValue("cash_rendering", data.payment_detail_cash_rendering);
    setFieldValue("amount", data.payment_detail_amount);
    setFieldValue("payment_mode", {
      value: paymentmode?.payment_mode,
      label: paymentmode?.payment_mode,
      payment_mode_id: paymentmode?.id,
    });
    setFieldValue("payment_mode_id", paymentmode?.id);

    // Franchise details
    setFieldValue("franchise", {
      label: data.franchise_obj?.franchise_code,
      value: data.franchise_obj?.id,
      franchise_id: data.franchise_obj?.id,
    });
  }, [registration_serach]);

  const formik = useFormik({
    initialValues: {
      zone: {},
      zone_id: "",
      patient_name: "",
      age: { age_day: "0", age_month: "0", age_year: "0" },
      date_of_birth: "",
      gender: "male",
      address: "",
      area: {},
      area_id: "",
      city: "",
      state: {},
      state_id: "",
      mobile: "",
      email: "",
      comments: "",
      weight: "",
      weight_unit: "KG",
      height: "",
      height_unit: "CM",
      LMP: "",
      blood_group: {},
      blood_group_id: "",

      refer_doctor: {},
      refer_doctor_id: "",
      refer_doctor_name: "",
      collection_type: {},
      collection_type_id: "",
      franchise_type: {},
      franchise_type_id: "",
      refer_by_hospital: "",
      lab_name: "",
      barcode_number: "",
      collection_boy: {},
      collection_boy_id: "",
      deliver_boy: {},
      deliver_boy_id: "",

      discount_type: "Disc Type Wise",
      discount: "",
      discount_unit: "Amount",
      approved_by: {},
      approved_by_id: "",
      discount_reason: "",
      coll_charge: "",
      adjustment: "",
      payment_mode: {},
      payment_mode_id: "",
      amount: "",
      cheque_card_number: "",
      bank_name: "",
      cash_rendering: "",
      final_amount: "",
      balance_amount: "",

      investigation_name: {},
      investigation_name_id: "",
      package_name: {},
      package_name_id: "",
      investigtion_details: [],
      package_details: [],
      franchise: {},
      franchise_id: "",
      paymentModechk: "",

      appointment_booking_id: "",
      company_id: companyLocalStorageId(),
    },

    validationSchema: addCategoryValidator,
    onSubmit: async ({ setSubmitting }) => {
      try {
        if (isDocumentRequired && !documentInfo?.data?.file_name) {
          showAlert("Document upload is required", "error");
          return;
        }

        function buildObject(
          values,
          _token,
          jwtAuthreducer,
          calculateNetAmount,
          sumMRP,
          dateTimeStringToEpoch,
        ) {
          const result = {};
          function addIfExists(key, value) {
            if (value || key === "balance_amount") {
              result[key] = value;
            }
          }

          // Populate the result object
          addIfExists("company_id", companyLocalStorageId());
          addIfExists("patient_name", values.patient_name);
          addIfExists(
            "age",
            "P" +
              (values.age.age_year && values.age.age_year !== ""
                ? values.age.age_year
                : 0) +
              "Y" +
              (values.age.age_month && values.age.age_month !== ""
                ? values.age.age_month
                : 0) +
              "M" +
              (values.age.age_day && values.age.age_day !== ""
                ? values.age.age_day
                : 0) +
              "D",
          );
          addIfExists("dob", values.date_of_birth);
          addIfExists("gender", values.gender);
          addIfExists("address", values.address);
          addIfExists("area_id", Number(values.area_id));
          addIfExists("city", values.city);
          addIfExists("state_id", Number(values.state_id));
          addIfExists("country_code", "IN");
          addIfExists("mobile", "+91" + values.mobile);
          addIfExists("email", values.email);
          addIfExists("comments", values.comments);
          addIfExists("refer_doctor_id", Number(values.refer_doctor_id));
          addIfExists("collection_type_id", Number(values.collection_type_id));
          // addIfExists("zone_id", Number(values.zone_id));
          addIfExists("zone_id", zoneLocalStorageId());
          addIfExists(
            "franchise_id",
            values.franchise_id ||
              Number(updatedFranchiseId) ||
              _token?.franchise_id,
          );
          addIfExists("approved_by", values.approved_by?.employee_code_id);
          addIfExists("is_active", true);
          addIfExists("created_by", jwtAuthreducer.user.employee_code_id);
          addIfExists("weight", Number(values.weight));
          addIfExists("height", Number(values.height));
          addIfExists("height_unit", values.height_unit);
          addIfExists("lmp", Number(values.LMP));
          addIfExists("blood_group", values.blood_group_id);
          addIfExists("refer_by_hospital", values.refer_by_hospital);
          addIfExists("lab_name", values.lab_name);
          // addIfExists("barcode_no", String(values.barcode_number));
          addIfExists("payment_mode_id", Number(values.payment_mode_id));

          addIfExists("cheque_or_card_no", values.cheque_card_number);
          addIfExists("bank_name", values.bank_name);
          addIfExists("cash_rendering", Number(values.cash_rendering));
          addIfExists("patient_id", patient_id ? Number(patient_id) : "");
          addIfExists(
            "patient_document_id",
            documentInfo?.data?.id ? Number(documentInfo?.data?.id) : "",
          );
          addIfExists(
            "payment_detail_id",
            paymentDetailId ? Number(paymentDetailId) : "",
          );
          addIfExists(
            "appointment_detail_id",
            appointmentDetailId ? Number(appointmentDetailId) : "",
          );
          addIfExists(
            "appointment_id",
            appointmentId ? Number(appointmentId) : "",
          );
          addIfExists("deliver_boy", values?.deliver_boy_id);
          addIfExists("collection_boy", values?.collection_boy_id);
          addIfExists("refer_doctor_name", values?.refer_doctor_name);

          // Calculate amounts
          // const netAmount = calculateNetAmount(
          //   sumMRP(values.investigtion_details),
          //   values?.discount_unit,
          //   Number(values?.discount),
          //   Number(values?.coll_charge),
          //   Number(values?.adjustment)
          // );

          const netAmount = calculateNetAmount(
            values?.paymentModechk === "CASH"
              ? sumMRP(values?.investigtion_details, values?.package_details)
              : sumRate(values?.investigtion_details, values?.package_details),
            values?.discount_unit,
            Number(values?.discount),
            // Number(values?.coll_charge),
            Number(values?.adjustment),
          );

          addIfExists(
            "amount",
            values.paymentModechk != "CASH" ? netAmount : Number(values.amount),
          );

          const totalGross = calculateNetAmount(
            values?.paymentModechk === "CASH"
              ? sumMRP(values?.investigtion_details, values?.package_details)
              : sumRate(values?.investigtion_details, values?.package_details),
          );
          // addIfExists("final_amount", netAmount);
          addIfExists("final_amount", totalGross);

          addIfExists("discount_type", values.discount_type);
          // addIfExists("discount_amount", Number(values.discount));
          // addIfExists("discount_percentage", Number(values.discount));
          values?.discount_unit === "Amount"
            ? addIfExists("discount_amount", Number(values.discount))
            : addIfExists("discount_percentage", Number(values.discount));

          addIfExists("discount_reason", values.discount_reason);
          addIfExists("collection_charge", Number(values.coll_charge));
          addIfExists("additional_charge", Number(values.adjustment));

          const amountAfterDiscount = calculateNetAmount(
            sumMRP(values?.investigtion_details, values?.package_details),
            values?.discount_unit,
            Number(values?.discount),
            // Number(values?.coll_charge),
            Number(values?.adjustment),
          );

          addIfExists("amount_after_discount", amountAfterDiscount);

          addIfExists(
            "balance_amount",
            amountAfterDiscount - Number(values.amount),
          );

          addIfExists("appointment_booking_id", appointmentBookingId);

          let pateint_investigtion_detailsinfo =
            values?.investigtion_details?.map((inv, index) => {
              let queryParameter = {};
              if (inv.read_only == false) {
                Object.assign(
                  queryParameter,
                  inv.investigation_id && {
                    investigation_id: Number(inv.investigation_id),
                  },
                  inv.mrp && { mrp: Number(inv.mrp) },
                  inv.discount && { discount: 1 },
                  { rate: inv.rate == 0 ? Number(inv.mrp) : Number(inv.rate) },
                  inv.is_urgent && { urgent: Boolean(Number(inv.is_urgent)) },
                  inv.urgent_delivery_time && {
                    urgent_delivery_time: dateTimeStringToEpoch(
                      inv.urgent_delivery_time,
                    ),
                  },
                  {
                    delivery_time: inv.delivery_time
                      ? dateToEpochUTC(inv.delivery_time)
                      : 0,
                  },
                  inv.barcode_id && { barcode_no: String(inv.barcode_id) },
                  {
                    is_third_party_barcode:
                      isThirdPartyBarcodeInvestigation[index] || false,
                  },
                  {
                    company_id: companyLocalStorageId(),
                  },
                );
              }
              return queryParameter;
            });

          let newArray = pateint_investigtion_detailsinfo.filter(
            (value) => Object.keys(value).length !== 0,
          );
          addIfExists("pateint_investigtion_details", newArray);

          // let pateint_package_detailsinfo = values?.package_details?.map(
          //   (inv) => {
          //     let queryParameter = {};
          //     if (inv.read_only == false) {
          //       Object.assign(
          //         queryParameter,
          //         inv.package_id && {
          //           package_id: Number(inv?.package_id),
          //         },
          //         inv.mrp && { mrp: Number(inv?.mrp) },
          //         inv.discount && { discount: 1 },
          //         { rate: inv?.rate == 0 ? Number(inv?.mrp) : Number(inv?.rate) },
          //         inv.is_urgent && { urgent: Boolean(Number(inv?.is_urgent)) },
          //         inv.urgent_delivery_time && {
          //           urgent_delivery_time: dateTimeStringToEpoch(
          //             inv?.urgent_delivery_time
          //           ),
          //         },
          //         inv.delivery_time && {
          //           delivery_time: dateTimeStringToEpoch(inv?.delivery_time),
          //         },
          //         inv.barcode_id && { barcode_no: String(inv?.barcode_id) },
          //         { is_third_party_barcode: inv?.is_third_party_barcode }
          //       );
          //     }
          //     return queryParameter;
          //   }
          // );
          // let newArrayPackage = pateint_package_detailsinfo.filter(
          //   (value) => Object.keys(value).length !== 0
          // );
          // addIfExists("patient_package_details", newArrayPackage);

          let patient_package_detailsinfo = values?.package_details?.map(
            (inv) => {
              let queryParameter = {};
              if (inv.read_only == false) {
                Object.assign(
                  queryParameter,
                  inv.package_id && { package_id: Number(inv?.package_id) },
                  inv.mrp && { mrp: Number(inv?.mrp) },
                  inv.discount && { discount: Number(inv?.discount) },
                  {
                    rate: inv?.rate == 0 ? Number(inv?.mrp) : Number(inv?.rate),
                  },
                  inv.is_urgent && { urgent: Boolean(Number(inv?.is_urgent)) },
                  inv.urgent_delivery_time && {
                    urgent_delivery_time: dateTimeStringToEpoch(
                      inv?.urgent_delivery_time,
                    ),
                  },
                  {
                    delivery_time: inv.delivery_time
                      ? dateToEpochUTC(inv.delivery_time)
                      : 0,
                  },
                  {
                    package_investigation_detail:
                      inv.package_investigations?.map(
                        (investigation, index) => ({
                          investigation_id: investigation.investigation_id
                            ? Number(investigation.investigation_id)
                            : 0,
                          is_third_party_barcode: isThirdPartyBarcode || false,
                          barcode_no:
                            barcodeDataState[index]?.barcode_no ??
                            (investigation?.barcode_obj?.barcode_no
                              ? String(investigation.barcode_obj.barcode_no)
                              : ""),
                              company_id: companyLocalStorageId(),
                        }),
                      ) || [],
                  },
                  {
                    company_id: companyLocalStorageId(),
                  },
                );
              }
              return queryParameter;
            },
          );

          let newArrayPackage = patient_package_detailsinfo.filter(
            (value) => Object.keys(value).length !== 0,
          );
          addIfExists("patient_package_details", newArrayPackage);

          return result;
        }

        setinvestigationval(0);
        values.investigtion_details.map((inv) => {
          if (inv.mrp <= 0) {
            setinvestigationval(1);
          }
        });
        if (investigationval == 0) {
          if (investigationIds?.length) {
            await dispatch(deleteNewRegistration(deletePayload));
          }
          if (packagesIds?.length) {
            await dispatch(deletePackageNewRegistration(deletePackagesPayload));
          }
          await dispatch(
            submitNewRegistration(
              buildObject(
                values,
                _token,
                jwtAuthreducer,
                calculateNetAmount,
                sumMRP,
                dateTimeStringToEpoch,
              ),
            ),
          );

          setSearchText("");
          setFieldValue("investigation_name", {});
          setFieldValue("investigation_name_id", "");

          setFieldValue("package_name", {});
          setFieldValue("package_id", "");

          setPackageInvestigationData([]);
          dispatch(clearNewRegistration());

          navigate("/registration");
        }
      } catch (error) {
        console.error("Form submission error:", error);
        showAlert(
          error.message || "Something went wrong. Please try again.",
          "danger",
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  const { errors, touched, values, handleSubmit, setFieldValue, isSubmitting } =
    formik;

  function calculateDateOfBirth(ageDays, ageMonths, ageYears) {
    if (ageYears == null || ageYears < 0) return "";
    if (ageMonths == null || ageMonths < 0 || ageMonths > 11) return "";
    if (ageDays == null || ageDays < 0) return "";

    let today = new Date();

    let birthYear = today.getFullYear() - Number(ageYears);
    let birthMonth = today.getMonth() - Number(ageMonths);
    let birthDay = today.getDate() - Number(ageDays);

    if (birthMonth < 0) {
      birthYear -= 1;
      birthMonth += 12;
    }

    if (birthDay < 0) {
      birthMonth -= 1;
      if (birthMonth < 0) {
        birthMonth = 11;
        birthYear -= 1;
      }
      let daysInPrevMonth = new Date(birthYear, birthMonth + 1, 0).getDate();
      birthDay += daysInPrevMonth;
    }

    let daysInBirthMonth = new Date(birthYear, birthMonth + 1, 0).getDate();
    if (birthDay > daysInBirthMonth) {
      birthDay = daysInBirthMonth;
    }

    let calculatedDate = new Date(birthYear, birthMonth, birthDay);
    if (
      calculatedDate.getDate() !== birthDay ||
      calculatedDate.getMonth() !== birthMonth ||
      calculatedDate.getFullYear() !== birthYear
    ) {
      return "";
    }

    return `${birthYear}-${String(birthMonth + 1).padStart(2, "0")}-${String(
      birthDay,
    ).padStart(2, "0")}`;
  }

  function calculateAge(birthDateString) {
    if (!birthDateString) return { age_year: 0, age_month: 0, age_day: 0 };

    let birthDate = new Date(birthDateString);
    let today = new Date();

    if (birthDate > today) {
      return { age_year: 0, age_month: 0, age_day: 0 };
    }

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return {
      age_year: Math.max(0, years),
      age_month: Math.max(0, months),
      age_day: Math.max(0, days),
    };
  }

  function convertTimestampToDatetimeLocal(timestamp) {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  // function sumMRP(investigations, packages) {
  //   let totalMRP = 0;
  //   investigations?.forEach((investigation) => {
  //     let mrpValue =
  //       typeof investigation.mrp === "string"
  //         ? parseFloat(investigation.mrp)
  //         : investigation.mrp;
  //     if (!isNaN(mrpValue)) {
  //       totalMRP += mrpValue;
  //     }
  //   });
  //   packages?.forEach((packages) => {
  //     let mrpValue =
  //       typeof packages.mrp === "string"
  //         ? parseFloat(packages.mrp)
  //         : packages.mrp;
  //     if (!isNaN(mrpValue)) {
  //       totalMRP += mrpValue;
  //     }
  //   });

  //   return totalMRP;
  // }

  function sumMRP(investigations, packages) {
    let totalMRP = 0;

    investigations?.forEach((investigation) => {
      if (investigation?.mrp != null) {
        // Check if investigation and mrp exist
        let mrpValue =
          typeof investigation.mrp === "string"
            ? parseFloat(investigation.mrp)
            : investigation.mrp;
        if (!isNaN(mrpValue)) {
          totalMRP += mrpValue;
        }
      }
    });

    packages?.forEach((pkg) => {
      if (pkg?.mrp != null) {
        // Check if package and mrp exist
        let mrpValue =
          typeof pkg.mrp === "string" ? parseFloat(pkg.mrp) : pkg.mrp;
        if (!isNaN(mrpValue)) {
          totalMRP += mrpValue;
        }
      }
    });

    return totalMRP;
  }

  // function sumRate(investigations, packages) {
  //   let totalRate = 0;
  //   investigations?.forEach((investigation) => {
  //     let rateValue =
  //       typeof investigation.rate === "string"
  //         ? parseFloat(investigation.rate)
  //         : investigation.rate;
  //     if (!isNaN(rateValue)) {
  //       totalRate += rateValue;
  //     }
  //   });
  //   packages?.forEach((packages) => {
  //     let rateValue =
  //       typeof packages.rate === "string"
  //         ? parseFloat(packages.rate)
  //         : packages.rate;
  //     if (!isNaN(rateValue)) {
  //       totalRate += rateValue;
  //     }
  //   });
  //   return totalRate;
  // }

  function sumRate(investigations, packages) {
    let totalRate = 0;

    investigations?.forEach((investigation) => {
      if (investigation?.rate != null) {
        let rateValue =
          typeof investigation.rate === "string"
            ? parseFloat(investigation.rate)
            : investigation.rate;
        if (!isNaN(rateValue)) {
          totalRate += rateValue;
        }
      }
    });

    packages?.forEach((pkg) => {
      if (pkg?.rate != null) {
        let rateValue =
          typeof pkg.rate === "string" ? parseFloat(pkg.rate) : pkg.rate;
        if (!isNaN(rateValue)) {
          totalRate += rateValue;
        }
      }
    });

    return totalRate;
  }

  const [manualAmount, setManualAmount] = useState("");

  useEffect(() => {
    if (!manualAmount) {
      setFieldValue(
        "amount",
        calculateNetAmount(
          sumMRP(values.investigtion_details, values?.package_details),
          values?.discount_unit,
          Number(values?.discount),
          // Number(values?.coll_charge),
          Number(values?.adjustment),
        ),
      );
    }
  }, [
    values.investigtion_details,
    values.package_details,
    values.discount_unit,
    values.discount,
    values.coll_charge,
    values.adjustment,
    manualAmount,
  ]);

  function calculateNetAmount(
    baseAmount,
    discountType = null,
    discountedAmo = 0,
    commissionCharges = 0,
    adjustments = 0,
  ) {
    let netAmount = baseAmount;

    if (discountType === "Amount") {
      netAmount -= discountedAmo;
    } else if (discountType === "Percent") {
      let discount = (discountedAmo / 100) * baseAmount;
      netAmount -= discount;
    }

    netAmount += commissionCharges;
    netAmount += adjustments;

    return netAmount;
  }

  function dateTimeStringToEpoch(dateTimeString) {
    if (dateTimeString) {
      const dateTimeParts = dateTimeString.split("T");
      const dateParts = dateTimeParts[0].split("-");
      const timeParts = dateTimeParts[1].split(":");

      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);
      const hour = parseInt(timeParts[0], 10);
      const minute = parseInt(timeParts[1], 10);

      const date = new Date(year, month, day, hour, minute, 0, 0);
      return date.getTime() / 1000;
    } else {
      return "";
    }
  }

  function dateToEpochUTC(dateString) {
    // Parse the date string parts
    const [datePart, timePart] = dateString.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);

    // Create date in UTC (months are 0-indexed in JavaScript)
    const date = new Date(Date.UTC(year, month - 1, day, hour, minute));
    return Math.floor(date.getTime() / 1000);
  }

  const { showAlert } = useAlert();
  useEffect(() => {
    if (new_registration?.patient_id) {
      // dispatch(clearBarcode())
      let receptUrl =
        "/invoice?appointment_id=" +
        new_registration?.appointment_id +
        "&patient_id=" +
        new_registration?.patient_id;
      setreceptUrl(receptUrl);
      showAlert(
        "Thank you! Your registration was successful! Your Appoinment ID is : " +
          new_registration?.appointment_id,
        "success",
      );
      formik.resetForm();
      setpatient_id("");
      setdocumentInfo();
      // dispatch(getBarcode(_token?.franchise_id));
    }
    //
  }, [new_registration, new_registration?.patient_id]);

  const submitSearch = () => {
    formik.resetForm();
    dispatch(cleartRegistrationSearch());
    dispatch(clearNewRegistration());
    setsearch_error(false);
    if (
      search_mobile == undefined &&
      search_appoinment == undefined &&
      search_paitent == undefined &&
      search_city == undefined &&
      search_state == undefined &&
      search_area == undefined &&
      search_dob == undefined &&
      search_from == undefined &&
      search_to == undefined
    ) {
      setsearch_error(true);
    } else if (
      search_mobile == null &&
      search_appoinment == null &&
      search_paitent == null &&
      search_city == null &&
      search_state == null &&
      search_area == null &&
      search_dob == null &&
      search_from == null &&
      search_to == null
    ) {
      setsearch_error(true);
    } else if (
      search_mobile == "" &&
      search_appoinment == "" &&
      search_paitent == "" &&
      search_city == "" &&
      search_state == "" &&
      search_area == "" &&
      search_dob == "" &&
      search_from == "" &&
      search_to == ""
    ) {
      setsearch_error(true);
    } else {
      setsearch_error(false);
      let searchValue = {
        mobile_no: search_mobile,
        appointment_id: search_appoinment,
        patient_name: search_paitent,
        city: search_city,
        state: search_state?.value,
        area: search_area?.value,
        dob: search_dob,
        date_from: search_from,
        date_to: search_to,
      };
      dispatch(submitRegistrationSearch(searchValue));

      setsearch_mobile("");
      // setsearch_appoinment("");
      setsearch_paitent("");
      setsearch_city("");
      setsearch_state("");
      setsearch_area("");
      setsearch_dob("");
      setsearch_from("");
      setsearch_to("");
    }
  };
  useEffect(() => {
    if (appointment_id) {
      dispatch(clearNewRegistration());
      setFieldValue("address", "");
      setFieldValue("city", "");
      setFieldValue("patient_name", "");
      setFieldValue("gender", "");
      setFieldValue("date_of_birth", "");
      setFieldValue("mobile", "");
      setFieldValue("email", "");
      setFieldValue("age.age_year", "");
      setFieldValue("age.age_month", "");
      setFieldValue("age.age_day", "");
      setFieldValue("comments", "");
      setpatient_id("");
      // setFieldValue("barcode_number", bar_code_info?.barcode_no ? bar_code_info?.barcode_no : "")
      setFieldValue("area", {});
      setFieldValue("state", {});
      let searchValue = {
        appointment_id: appointment_id,
        edit: 1,
      };
      dispatch(submitRegistrationSearch(searchValue));
    } else {
      dispatch(clearNewRegistration());
      formik.resetForm();
      setpatient_id();
      setdocumentInfo();
      setappointmentId();
      setpaymentDetailId();
      setappointmentDetailId();
    }
    //
  }, [appointment_id]);

  const franchise_id = localStorage.getItem("franchise_id");
  const new_registration_franchise_id = localStorage.getItem(
    "new_registration_franchise_id",
  );

  const defaultFranchise =
    franchise_list?.data?.find(
      (item) => item.id === parseInt(new_registration_franchise_id),
    ) ||
    franchise_list?.data?.find((item) => item.id === parseInt(franchise_id));

  const franchiseOptions = franchise_list?.data?.map((item) => ({
    value: item.company_name,
    label: `${item.company_name} , ${item.franchise_code}`,
    franchise_id: item.id,
    payment_mode: item?.payment_mode,
    allow_preprint_barcode: item?.allow_preprint_barcode,
  }));

  const selectedFranchise =
    franchiseOptions?.find((opt) => opt.franchise_id === values.company_name) ||
    (defaultFranchise &&
      franchiseOptions?.find(
        (opt) => opt.franchise_id === defaultFranchise.id,
      ));

  const newLocalFranchiseId = localStorage.getItem(
    "new_registration_franchise_id",
  );

  const new_registration_franchise_idNumber = newLocalFranchiseId
    ? Number(newLocalFranchiseId)
    : null;

  // const checkFranchisePaymentMode = franchise_list?.data?.find(
  //   (item) => item.id === franchiseIdNumber
  // );

  useEffect(() => {
    if (selectedFranchise && appointment_id) {
      localStorage.setItem(
        "new_registration_franchise_id",
        String(selectedFranchise?.franchise_id),
      );
    }
  }, [selectedFranchise, appointment_id]);

  useEffect(() => {
    if (defaultFranchise) {
      setpaymentMode(defaultFranchise?.payment_mode);
    }
  }, [defaultFranchise, setFieldValue]);

  useEffect(() => {
    if (paymentMode === "CREDIT" || values?.paymentModechk === "CREDIT") {
      setFieldValue("discount", 0);
    } else if (values?.investigtion_details?.length) {
      const totalDiscount = values.investigtion_details.reduce(
        (acc, item) => acc + Number(item.discount || 0),
        0,
      );
      setFieldValue("discount", totalDiscount);
    }
  }, [
    values.investigtion_details,
    setFieldValue,
    paymentMode,
    values?.paymentModechk,
  ]);

  useEffect(() => {
    if (values?.package_details?.length) {
      const totalDiscount = values.package_details.reduce(
        (acc, item) => acc + Number(item.discount || 0),
        0,
      );
      setFieldValue("discount", totalDiscount);
    }
  }, [values.package_details, setFieldValue]);

  const ToggleInfo = ({ show, onClick }) => {
    return (
      <div
        className={`mb-3 text-white ${show ? "bg-danger" : "bg-primary"}`}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          padding: "3px 6px",
          fontSize: "12px",
          borderRadius: "4px",
          cursor: "pointer",
          userSelect: "none",
          width: "auto",
          marginLeft: "10px",
        }}
        onClick={onClick}
      >
        <i className={`fas fa-${show ? "minus" : "plus"}`}></i>{" "}
        {show ? "Hide Additional Info" : "Show Additional Info"}
      </div>
    );
  };

  const {
    data: checkNewRegistrationAllow,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery(
    ["fetch-newregistration-check", selectedFranchise?.franchise_id],
    () => checkNewRegistration(selectedFranchise?.franchise_id),
    {
      staleTime: STALE_TIME,
      enabled: !!selectedFranchise,
    },
  );

  const cursorPositionRef = useRef(null);
  const inputRef = useRef(null);

  // Apply cursor position after render
  useEffect(() => {
    if (inputRef.current && cursorPositionRef.current !== null) {
      inputRef.current.setSelectionRange(
        cursorPositionRef.current,
        cursorPositionRef.current,
      );
      cursorPositionRef.current = null; // Clear it after use
    }
  });

  const ageYearRef = useRef(null);
  const genderRef = useRef(null);
  const referDoctorRef = useRef(null);
  const labNameRef = useRef(null);
  const investigationRef = useRef(null);
  const submitButtonRef = useRef(null);

  const [expandedInvestigations, setExpandedInvestigations] = useState({});

  const toggleInvestigationDetails = (index) => {
    setExpandedInvestigations((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    if (values?.investigtion_details?.length > 0) {
      const lastIndex = values.investigtion_details.length - 1;

      setExpandedInvestigations((prev) => {
        const hasAnyExpanded = Object.keys(prev).length > 0;

        if (hasAnyExpanded) {
          return {};
        }

        return prev;
      });
    }
  }, [values?.investigtion_details?.length]);

  const [showPackageDetails, setShowPackageDetails] = useState(false);

  const togglePackageDetails = () => {
    setShowPackageDetails(!showPackageDetails);
  };

  useEffect(() => {
    if (appointment_id) {
      setShowPackageDetails(true);
    }
  }, [appointment_id]);

  const BarcodeInput = ({ investigation, handleBarcodeChange, disabled }) => {
    const timeoutRef = useRef(null);
    const inputRef = useRef(null);
    const [localValue, setLocalValue] = useState(
      investigation?.barcode_obj?.barcode_no || "",
    );

    useEffect(() => {
      setLocalValue(investigation?.barcode_obj?.barcode_no || "");
    }, [investigation?.barcode_obj?.barcode_no]);

    const debouncedChange = useCallback(
      (newValue) => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
          handleBarcodeChange(newValue, investigation);
        }, 500);
      },
      [handleBarcodeChange, investigation],
    );

    const handleChange = (e) => {
      const newValue = e.target.value;
      setLocalValue(newValue);
      debouncedChange(newValue);
    };

    return (
      <input
        ref={inputRef}
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder="Not Assigned"
        style={{
          width: "100%",
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          fontSize: "0.875rem",
        }}
        disabled={disabled}
      />
    );
  };

  useEffect(() => {
    if (!values?.investigtion_details?.length) return;

    setPackageInvestigationData((prevData) => {
      const updatedData = [...prevData];

      values.investigtion_details.forEach((investigation) => {
        const sampleType = investigation.sample_type;
        const barcode = investigation.barcode_id || "";

        updatedData.forEach((pkgInv, idx) => {
          const pkgSampleType = pkgInv?.sample_type_obj?.[0]?.sample_type;

          if (pkgSampleType === sampleType) {
            updatedData[idx] = {
              ...pkgInv,
              barcode_obj: {
                ...pkgInv.barcode_obj,
                barcode_no: barcode,
              },
            };
          }
        });
      });

      return updatedData;
    });

    const updatedPackageDetails = values.package_details?.map((pkg) => {
      return {
        ...pkg,
        package_investigations: pkg.package_investigations?.map(
          (investigation) => {
            const matchingInvestigation = values.investigtion_details.find(
              (inv) =>
                inv.sample_type ===
                investigation?.sample_type_obj?.[0]?.sample_type,
            );

            if (matchingInvestigation) {
              return {
                ...investigation,
                barcode_obj: {
                  ...investigation.barcode_obj,
                  barcode_no: matchingInvestigation.barcode_id || "",
                },
              };
            }
            return investigation;
          },
        ),
      };
    });

    if (
      JSON.stringify(updatedPackageDetails) !==
      JSON.stringify(values.package_details)
    ) {
      setFieldValue("package_details", updatedPackageDetails);
    }
  }, [values.package_details]);

  useEffect(() => {
    if (!packageInvestigationData?.length) return;
    packageInvestigationData.forEach((pkgInv) => {
      const pkgSampleType = pkgInv?.sample_type_obj?.[0]?.sample_type;
      const barcode = pkgInv?.barcode_obj?.barcode_no || "";

      values.investigtion_details?.forEach((investigation, idx) => {
        if (investigation.sample_type === pkgSampleType) {
          setFieldValue(`investigtion_details.${idx}.barcode_id`, barcode);
        }
      });
    });
  }, [values?.investigtion_details]);

  useEffect(() => {
    if (
      appointment_id &&
      values?.package_details &&
      values.package_details.length > 0
    ) {
      const allInvestigations = values.package_details.reduce((acc, pkg) => {
        if (
          pkg.package_investigations &&
          pkg.package_investigations.length > 0
        ) {
          return [...acc, ...pkg.package_investigations];
        }
        return acc;
      }, []);

      setPackageInvestigationData(allInvestigations);
    }
  }, [appointment_id, values?.package_details]);

  const [menuIsOpen, setMenuIsOpen] = useState(true);
  const [packageMenuIsOpen, setPackageMenuIsOpen] = useState(true);

  return (
    <div className="registration-form-container">
      <div className="box mb-4">
        <div class="boxHeader d-flex align-items-center border-bottom pb-1 mb-1">
          <h1 class="mb-0 text-primary fw-bold" style={{ fontSize: "18px" }}>
            New Registration
          </h1>
        </div>

        <div
          className="boxBody"
          // style={{
          //   opacity: checkNewRegistrationAllow?.data?.download_allowed
          //     ? 1
          //     : 0.5,
          //   pointerEvents: checkNewRegistrationAllow?.data?.download_allowed
          //     ? "auto"
          //     : "none",
          // }}
        >
          <>
            <FormikProvider value={formik}>
              <Form onSubmit={handleSubmit} noValidate>
                <div
                  className="heading-form"
                  style={{ marginBottom: "8px", paddingBottom: "8px" }}
                >
                  Patient Details
                </div>

                <div className="row">
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">
                      Patient Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      ref={inputRef}
                      name="patient_name"
                      type="text"
                      className="form-control"
                      value={values.patient_name || ""}
                      onClick={(e) => {
                        cursorPositionRef.current = e.target.selectionStart;
                      }}
                      onChange={(e) => {
                        cursorPositionRef.current = e.target.selectionStart;
                        setFieldValue(
                          "patient_name",
                          e.target.value.toUpperCase(),
                        );
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(() => ageYearRef?.current?.focus(), 0);
                        }
                      }}
                      tabIndex={1}
                    />
                    {Boolean(errors.patient_name) && (
                      <span className="text-danger">
                        {touched.patient_name && errors.patient_name}
                      </span>
                    )}
                  </div>

                  <div className={`col-md-3 mb-3`}>
                    <div>
                      <label className="mb-2">
                        Age <span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="input-group">
                        <input
                          placeholder="Year"
                          name="age_year"
                          type="number"
                          className="form-control"
                          value={values.age.age_year}
                          onChange={(e) => {
                            setFieldValue("age.age_year", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_year == 0) {
                              setFieldValue("age.age_year", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_year == "") {
                              setFieldValue("age.age_year", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                          ref={ageYearRef}
                          tabIndex={2}
                          onKeyDown={(e) => {
                            if (e.key === "Tab") {
                              e.preventDefault();
                              setTimeout(() => genderRef.current?.focus(), 0);
                            }
                          }}
                        />

                        <input
                          placeholder="Month"
                          name="age_month"
                          type="number"
                          className="form-control"
                          value={values.age.age_month}
                          onChange={(e) => {
                            setFieldValue("age.age_month", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_month == 0) {
                              setFieldValue("age.age_month", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_month == "") {
                              setFieldValue("age.age_month", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                        />
                        <input
                          placeholder="Day"
                          name="age_day"
                          type="number"
                          className="form-control"
                          value={values.age.age_day}
                          onChange={(e) => {
                            setFieldValue("age.age_day", e.target.value);
                          }}
                          onFocus={() => {
                            if (values.age.age_day == 0) {
                              setFieldValue("age.age_day", "");
                            }
                          }}
                          onBlur={() => {
                            if (values.age.age_day == "") {
                              setFieldValue("age.age_day", 0);
                            } else {
                              setFieldValue(
                                "date_of_birth",
                                calculateDateOfBirth(
                                  values.age.age_day,
                                  values.age.age_month,
                                  values.age.age_year,
                                ),
                              );
                            }
                          }}
                          onKeyDown={(e) =>
                            e.key === "Tab" && genderRef.current.focus()
                          }
                        />
                      </div>
                    </div>

                    {Boolean(errors.age) && (
                      <span className="text-danger">
                        {touched.age && errors.age}
                      </span>
                    )}
                  </div>

                  {/* <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">
                      Date Of Birth <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      name="date_of_birth"
                      type="date"
                      className="form-control"
                      value={values.date_of_birth}
                      onChange={(e) => {
                        setFieldValue("date_of_birth", e.target.value);
                        let { age_day, age_month, age_year } = calculateAge(
                          e.target.value
                        );
                        setFieldValue("age.age_day", age_day);
                        setFieldValue("age.age_month", age_month);
                        setFieldValue("age.age_year", age_year);
                      }}
                    />
                    {Boolean(errors.date_of_birth) && (
                      <span className="text-danger">
                        {touched.date_of_birth && errors.date_of_birth}
                      </span>
                    )}
                  </div> */}

                  <div className={`col-md-2 mb-2`}>
                    <label className="mb-2">Gender</label>
                    <select
                      value={values.gender}
                      className="form-control"
                      onChange={(e) => setFieldValue("gender", e.target.value)}
                      ref={genderRef}
                      tabIndex={3}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(() => referDoctorRef.current?.focus(), 0);
                        }
                      }}
                    >
                      {[
                        { key: "male", value: "male", label: "Male" },
                        { key: "female", value: "female", label: "Female" },
                        {
                          key: "transgender",
                          value: "transgender",
                          label: "Transgender",
                        },
                      ].map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-md-2 mb-2">
                    <label className="">
                      Document{" "}
                      {isDocumentRequired && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary mt-2"
                        onClick={() => handleDocuments(rowData)}
                      >
                        Upload Document
                      </button>
                      {documentInfo?.data?.file_name && (
                        <span
                          style={{
                            fontSize: "15px",
                            fontWeight: "bold",
                            padding: "5px",
                          }}
                        >
                          {documentInfo?.data?.file_name}
                        </span>
                      )}
                      {isDocumentRequired && !documentInfo?.data?.file_name && (
                        <span className="text-danger d-block mt-1 fs-4 fw-bold">
                          Document upload is required
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-md-2 mb-2">
                    <ToggleInfo
                      show={showAdditionalInfo}
                      onClick={() => setShowAdditionalInfo(!showAdditionalInfo)}
                    />
                  </div>

                  {showAdditionalInfo && (
                    <div className="row">
                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">
                          Date Of Birth <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          name="date_of_birth"
                          type="date"
                          className="form-control"
                          value={values.date_of_birth}
                          onChange={(e) => {
                            setFieldValue("date_of_birth", e.target.value);
                            let { age_day, age_month, age_year } = calculateAge(
                              e.target.value,
                            );
                            setFieldValue("age.age_day", age_day);
                            setFieldValue("age.age_month", age_month);
                            setFieldValue("age.age_year", age_year);
                          }}
                        />
                        {Boolean(errors.date_of_birth) && (
                          <span className="text-danger">
                            {touched.date_of_birth && errors.date_of_birth}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Address</label>
                        <input
                          name="address"
                          type="text"
                          className="form-control"
                          value={values.address}
                          onChange={(e) =>
                            setFieldValue("address", e.target.value)
                          }
                        />
                        {Boolean(errors.address) && (
                          <span className="text-danger">
                            {touched.address && errors.address}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Area</label>
                        <Select
                          options={area_list?.data?.map((item) => {
                            return {
                              value: item.area_name,
                              label: item.area_name,
                              area_id: item.id,
                            };
                          })}
                          name="area"
                          isClearable
                          placeholder="Select Area"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("area", val);
                            setFieldValue("area_id", val?.area_id);
                          }}
                        />
                        {Boolean(errors.area_id) && (
                          <span className="text-danger">
                            {touched.area_id && errors.area_id}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">City</label>
                        <input
                          name="city"
                          type="text"
                          className="form-control"
                          value={values.city}
                          onChange={(e) =>
                            setFieldValue("city", e.target.value)
                          }
                        />
                        {Boolean(errors.city) && (
                          <span className="text-danger">
                            {touched.city && errors.city}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">State</label>
                        <Select
                          options={state_list?.map((item) => {
                            return {
                              value: item.state,
                              label: item.state,
                              state_id: item.state_id,
                            };
                          })}
                          isClearable
                          value={values.state || null}
                          placeholder="Select State"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("state", val);
                            setFieldValue("state_id", val?.state_id);
                          }}
                        />
                        {Boolean(errors.state_id) && (
                          <span className="text-danger">
                            {touched.state_id && errors.state_id}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Mobile Number</label>
                        <input
                          name="mobile"
                          type="number"
                          className="form-control"
                          value={values.mobile}
                          onChange={(e) =>
                            setFieldValue("mobile", e.target.value)
                          }
                        />
                        {Boolean(errors.mobile) && (
                          <span className="text-danger">
                            {touched.mobile && errors.mobile}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Email ID</label>
                        <input
                          name="email"
                          type="text"
                          className="form-control"
                          value={values.email}
                          onChange={(e) =>
                            setFieldValue("email", e.target.value)
                          }
                        />
                        {Boolean(errors.email) && (
                          <span className="text-danger">
                            {touched.email && errors.email}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Weight</label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            aria-label="Text input with dropdown button"
                            value={values.weight}
                            onChange={(e) =>
                              setFieldValue("weight", e.target.value)
                            }
                          />
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {values.weight_unit}
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li
                              onClick={() => setFieldValue("weight_unit", "KG")}
                            >
                              <span className="dropdown-item">KG</span>
                            </li>
                          </ul>
                        </div>
                        {Boolean(errors.weight) && (
                          <span className="text-danger">
                            {touched.weight && errors.weight}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Height</label>
                        <div className="input-group">
                          <input
                            type="number"
                            className="form-control"
                            aria-label="Text input with dropdown button"
                            value={values.height}
                            onChange={(e) =>
                              setFieldValue("height", e.target.value)
                            }
                          />
                          <button
                            className="btn btn-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            {values.height_unit}
                          </button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            <li
                              onClick={() => setFieldValue("height_unit", "CM")}
                            >
                              <span className="dropdown-item">CM</span>
                            </li>
                            <li
                              onClick={() => setFieldValue("height_unit", "IN")}
                            >
                              <span className="dropdown-item">IN</span>
                            </li>
                          </ul>
                        </div>
                        {Boolean(errors.height) && (
                          <span className="text-danger">
                            {touched.height && errors.height}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">LMP</label>
                        <input
                          name="LMP"
                          type="number"
                          className="form-control"
                          value={values.LMP}
                          onChange={(e) => setFieldValue("LMP", e.target.value)}
                        />
                        {Boolean(errors.LMP) && (
                          <span className="text-danger">
                            {touched.LMP && errors.LMP}
                          </span>
                        )}
                      </div>

                      <div className={`col-md-3 mb-3`}>
                        <label className="mb-2">Blood Group</label>
                        <Select
                          options={[
                            {
                              value: "A",
                              label: "A",
                            },
                            {
                              value: "A+",
                              label: "A+",
                            },
                            {
                              value: "B",
                              label: "B",
                            },
                            {
                              value: "B+",
                              label: "B+",
                            },
                          ]}
                          name="refer_doctor"
                          isClearable
                          value={values.blood_group || null}
                          placeholder="Select Blood Group"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          onChange={(val) => {
                            setFieldValue("blood_group", val);
                            setFieldValue("blood_group_id", val?.value);
                          }}
                        />
                        {Boolean(errors.blood_group_id) && (
                          <span className="text-danger">
                            {touched.blood_group_id && errors.blood_group_id}
                          </span>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {showAdditionalInfo && (
                  <div className="row">
                    <div className="">
                      <label className="mb-2">Comments</label>
                      <textarea
                        className="form-control"
                        id="comments"
                        rows="2"
                        value={values.comments}
                        onChange={(e) =>
                          setFieldValue("comments", e.target.value)
                        }
                      ></textarea>
                    </div>
                  </div>
                )}

                {/* Doctor Details */}

                <div
                  className="heading-form"
                  style={{ marginBottom: "8px", paddingBottom: "8px" }}
                >
                  Doctor Details
                </div>

                <div className="row">
                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Refer Doctor</label>
                    <input
                      name="refer_doctor_name"
                      type="text"
                      className="form-control"
                      value={values?.refer_doctor_name}
                      onChange={(e) =>
                        setFieldValue(
                          "refer_doctor_name",
                          e.target.value.toUpperCase(),
                        )
                      }
                      ref={referDoctorRef}
                      tabIndex={4}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(() => labNameRef.current?.focus(), 0);
                        }
                      }}
                    />
                    {Boolean(errors.refer_doctor_name) && (
                      <span className="text-danger">
                        {touched.refer_doctor_name && errors.refer_doctor_name}
                      </span>
                    )}
                  </div>

                  {/* <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Refer By Hospital</label>
                    <input
                      name="refer_by_hospital"
                      type="text"
                      className="form-control"
                      value={values.refer_by_hospital}
                      onChange={(e) =>
                        setFieldValue("refer_by_hospital", e.target.value)
                      }
                    />
                    {Boolean(errors.refer_by_hospital) && (
                      <span className="text-danger">
                        {touched.refer_by_hospital && errors.refer_by_hospital}
                      </span>
                    )}
                  </div> */}

                  <div className={`col-md-3 mb-3`}>
                    <label className="mb-2">Lab Name</label>
                    <input
                      name="lab_name"
                      type="text"
                      className="form-control"
                      value={values.lab_name}
                      onChange={(e) =>
                        setFieldValue("lab_name", e.target.value)
                      }
                      ref={labNameRef}
                      tabIndex={5}
                      onKeyDown={(e) => {
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setTimeout(
                            () => investigationRef.current?.focus(),
                            0,
                          );
                        }
                      }}
                    />
                    {Boolean(errors.lab_name) && (
                      <span className="text-danger">
                        {touched.lab_name && errors.lab_name}
                      </span>
                    )}
                  </div>

                  <div className="col-md-3 ml-1">
                    <label className="mb-2">Select Franchise</label>
                    <Select
                      options={franchiseOptions}
                      name="franchise_dropdown"
                      // isClearable
                      isDisabled={!!appointment_id}
                      value={selectedFranchise}
                      placeholder="Select Franchise"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      onChange={(val) => {
                        setFieldValue("company_name", val);
                        setFieldValue("franchise_id", val?.franchise_id);

                        setpaymentMode(val?.payment_mode);

                        if (val?.payment_mode !== "CASH") {
                          setFieldValue("payment_mode_id", 1);
                          setFieldValue("paymentModechk", val?.payment_mode);
                          setFieldValue("amount", 0);
                          setFieldValue("payment_mode", {
                            value: "CASH",
                            label: "CASH",
                            payment_mode_id: 1,
                          });
                        } else {
                          setFieldValue("paymentModechk", val?.payment_mode);
                        }

                        localStorage.setItem(
                          "new_registration_franchise_id",
                          val?.franchise_id || "",
                        );

                        setSearchText("");
                        setFieldValue("investigation_name", {});
                        setFieldValue("investigation_name_id", "");

                        setFieldValue("package_name", {});
                        setFieldValue("package_id", "");
                        setFieldValue("investigtion_details", []);
                        setFieldValue("package_details", []);

                        setPackageInvestigationData([]);

                        // window.location.reload();
                      }}
                    />
                  </div>
                </div>

                {/* Investigation Details */}

                <>
                  <div
                    className="heading-form text-primary"
                    style={{ marginBottom: "8px", paddingBottom: "8px" }}
                  >
                    Investigation Details
                  </div>

                  <FieldArray name="investigtion_details">
                    {({ insert, remove, push }) => (
                      <>
                        <div
                          className="gap-3 d-flex flex-row mb-2"
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                          }}
                        >
                          <div className="d-flex gap-2 align-items-center">
                            <label
                              style={{ fontWeight: "bold", color: "#333" }}
                            >
                              Total MRP :
                            </label>
                            <label
                              style={{
                                fontSize: "16px",
                                color: "#28a745",
                                fontWeight: "bold",
                              }}
                            >
                              ₹
                              {Math.ceil(
                                calculateNetAmount(
                                  sumMRP(
                                    values.investigtion_details,
                                    values?.package_details,
                                  ),
                                ),
                              )}
                            </label>
                          </div>

                          <div
                            style={{
                              borderLeft: "1px solid #ddd",
                              height: "20px",
                              alignSelf: "center",
                            }}
                          ></div>

                          <div className="d-flex gap-2 align-items-center">
                            <label
                              style={{ fontWeight: "bold", color: "#333" }}
                            >
                              Lab Rate :
                            </label>
                            <label
                              style={{
                                fontSize: "16px",
                                color: "#007bff",
                                fontWeight: "bold",
                              }}
                            >
                              ₹
                              {Math.ceil(
                                calculateNetAmount(
                                  sumRate(
                                    values.investigtion_details,
                                    values?.package_details,
                                  ),
                                ),
                              )}
                            </label>
                          </div>
                        </div>
                        <div className="row" style={{ minHeight: "150px" }}>
                          <div className="col-md-3 col-12 mb-3">
                            <div className="card h-100">
                              <div className="card-header">
                                <h6 className="mb-0 text-primary">
                                  Select Investigation
                                </h6>
                              </div>

                              <div className="card-body">
                                <Select
                                  ref={investigationRef}
                                  tabIndex={6}
                                  menuIsOpen={menuIsOpen}
                                  onMenuOpen={() => setMenuIsOpen(true)}
                                  onMenuClose={() => {
                                    return false;
                                  }}
                                  value={
                                    values.investigation_name &&
                                    values.investigation_name.value
                                      ? values.investigation_name
                                      : null
                                  }
                                  onKeyDown={(e) => {
                                    if (e.key === "Tab") {
                                      e.preventDefault();
                                      setTimeout(
                                        () => submitButtonRef.current?.focus(),
                                        0,
                                      );
                                    }

                                    if (e.key === "Escape") {
                                      setMenuIsOpen(false);
                                    }
                                  }}
                                  options={investigation_list?.data?.map(
                                    (item) => {
                                      return {
                                        value: item?.investigation_name,
                                        label: item?.investigation_name,
                                        investigation_id: item?.id,
                                      };
                                    },
                                  )}
                                  onSearch={(value) => setSearchText(value)}
                                  filterOption={(option, inputValue) => {
                                    const labelText =
                                      option.label?.toLowerCase() || "";
                                    const input = inputValue.toLowerCase();

                                    if (searchType === "first") {
                                      const startsWithMatch =
                                        labelText.startsWith(input);
                                      return startsWithMatch;
                                    } else {
                                      return labelText.includes(input);
                                    }
                                  }}
                                  filterSort={(optionA, optionB) => {
                                    if (searchType !== "first") return 0;

                                    const input = searchText.toLowerCase();
                                    const a = optionA.label.toLowerCase();
                                    const b = optionB.label.toLowerCase();

                                    const startsWithA = a.startsWith(input);
                                    const startsWithB = b.startsWith(input);

                                    if (startsWithA && !startsWithB) return -1;
                                    if (!startsWithA && startsWithB) return 1;

                                    return a.localeCompare(b);
                                  }}
                                  name="investigation_name"
                                  isClearable
                                  placeholder="Select Investigation Name"
                                  menuPortalTarget={null}
                                  menuPosition="static"
                                  menuPlacement="auto"
                                  components={{
                                    DropdownIndicator: (props) => {
                                      let touchStarted = false;

                                      const handleClick = (e) => {
                                        if (touchStarted) {
                                          touchStarted = false;
                                          return;
                                        }
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setMenuIsOpen(!menuIsOpen);
                                      };

                                      const handleTouchStart = (e) => {
                                        touchStarted = true;
                                        e.preventDefault();
                                        e.stopPropagation();
                                      };

                                      const handleTouchEnd = (e) => {
                                        if (touchStarted) {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setMenuIsOpen(!menuIsOpen);
                                          setTimeout(() => {
                                            touchStarted = false;
                                          }, 100);
                                        }
                                      };

                                      return (
                                        <div
                                          {...props.innerProps}
                                          onClick={handleClick}
                                          onTouchStart={handleTouchStart}
                                          onTouchEnd={handleTouchEnd}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            touchAction: "manipulation",
                                            WebkitTouchCallout: "none",
                                            WebkitUserSelect: "none",
                                            userSelect: "none",
                                          }}
                                        >
                                          <svg
                                            height="20"
                                            width="20"
                                            viewBox="0 0 20 20"
                                            style={{
                                              transform: menuIsOpen
                                                ? "rotate(180deg)"
                                                : "rotate(0deg)",
                                              transition: "transform 0.2s",
                                              pointerEvents: "none",
                                            }}
                                          >
                                            <path
                                              d="m4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                                              fill="currentColor"
                                            />
                                          </svg>
                                        </div>
                                      );
                                    },

                                    Option: (props) => {
                                      return (
                                        <div
                                          {...props.innerProps}
                                          onClick={(e) => {
                                            props.selectOption(props.data);

                                            setTimeout(
                                              () => setMenuIsOpen(true),
                                              0,
                                            );
                                          }}
                                          style={{
                                            ...props.innerProps.style,
                                            backgroundColor: props.isFocused
                                              ? "#f0f0f0"
                                              : "white",
                                            cursor: "pointer",
                                            padding: "8px 12px",
                                          }}
                                        >
                                          {props.children}
                                        </div>
                                      );
                                    },
                                  }}
                                  styles={{
                                    menu: (base) => ({
                                      ...base,
                                      position: "static",
                                      zIndex: 9999,
                                      boxShadow:
                                        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                                    }),
                                    menuList: (base) => ({
                                      ...base,
                                      position: "static",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                    }),
                                    control: (base, state) => ({
                                      ...base,
                                      zIndex: 1,

                                      boxShadow: state.isFocused
                                        ? base.boxShadow
                                        : base.boxShadow,
                                    }),

                                    valueContainer: (base) => ({
                                      ...base,
                                      cursor: "text",
                                    }),
                                  }}
                                  onInputChange={(inputValue, { action }) => {
                                    if (action === "input-change") {
                                      setSearchText(inputValue);
                                    }
                                  }}
                                  onChange={async (val) => {
                                    setFieldValue("investigation_name", val);
                                    setFieldValue(
                                      "investigation_name_id",
                                      val?.investigation_id,
                                    );

                                    setTimeout(() => setMenuIsOpen(true), 0);

                                    let franchiseIdToUse =
                                      values?.franchise_id ||
                                      _token?.franchise_id ||
                                      franchise_id;
                                    if (!values?.franchise_id) {
                                      const storedFranchiseId =
                                        localStorage.getItem(
                                          "new_registration_franchise_id",
                                        );
                                      if (storedFranchiseId) {
                                        franchiseIdToUse = storedFranchiseId;
                                      }
                                    }

                                    if (val) {
                                      if (franchiseIdToUse) {
                                        let data1 = await axiosInstance.get(
                                          `LIS/rate/list/${val?.investigation_id}/${franchiseIdToUse}`,
                                        );

                                        let rateData = data1?.data[0];
                                        setIsDocumentRequired(
                                          rateData?.upload_required === true,
                                        );

                                        const { data } =
                                          await axiosInstance.get(
                                            `LIS/franchise/get/barcode?franchise_id=${franchiseIdToUse}&investigation_id=${
                                              val?.investigation_id
                                            }&appointment_booking_id=${
                                              appointmentBookingData?.id ||
                                              appointmentBookingId
                                            }${
                                              rateData?.sample_type
                                                ? `&sample_type=${rateData.sample_type}`
                                                : ""
                                            }`,
                                          );

                                        const currentFranchise =
                                          franchiseOptions?.find(
                                            (franchise) =>
                                              franchise.franchise_id ==
                                              franchiseIdToUse,
                                          );

                                        const shouldIncludeBarcode =
                                          currentFranchise?.allow_preprint_barcode !==
                                          true;

                                        let barcodedataFinal = data?.barcode_no;

                                        if (
                                          rateData?.sample_type &&
                                          sampleTypeBarcodeCache[
                                            rateData.sample_type
                                          ]
                                        ) {
                                          barcodedataFinal =
                                            sampleTypeBarcodeCache[
                                              rateData.sample_type
                                            ];
                                        }

                                        const hasInvestigation = (
                                          list,
                                          investigationId,
                                        ) =>
                                          list?.length > 0 &&
                                          list.some(
                                            (item) =>
                                              item.investigation_id ===
                                              investigationId,
                                          );

                                        const already =
                                          hasInvestigation(
                                            values?.package_details?.[0]
                                              ?.package_investigations,
                                            val?.investigation_id,
                                          ) ||
                                          hasInvestigation(
                                            values?.investigtion_details,
                                            val?.investigation_id,
                                          );

                                        console.log(
                                          "******************already******************",
                                          already,
                                        );
                                        console.log(
                                          "******************rateData******************",
                                          rateData,
                                        );

                                        if (
                                          rateData?.rate === 0 ||
                                          rateData?.mrp_rate === 0
                                        ) {
                                          setShowRateNotConfiguredModal(true);
                                        } else if (
                                          rateData?.mrp_rate > 0 &&
                                          !already
                                        ) {
                                          const newIndex =
                                            values?.investigtion_details
                                              ?.length || 0;

                                          const cachedBarcode =
                                            sampleTypeBarcodeCache[
                                              rateData?.sample_type
                                            ];
                                          const finalBarcode =
                                            cachedBarcode || barcodedataFinal;

                                          push({
                                            investigation_id:
                                              val?.investigation_id,
                                            investigation_name: val?.value,
                                            discount: 0,
                                            mrp: rateData?.mrp_rate,
                                            rate: rateData?.rate,
                                            is_urgent: "0",
                                            // `delivery_days` is a duration, not a
                                            // datetime-local value. Keep the date
                                            // empty until the user selects it.
                                            delivery_time: "",
                                            ...(shouldIncludeBarcode && {
                                              barcode_id: finalBarcode,
                                              barcode_id_main: finalBarcode,
                                            }),
                                            is_third_party_barcode: false,
                                            read_only: false,
                                            sample_type: rateData?.sample_type,
                                            delivery_days:
                                              rateData?.delivery_days,
                                          });

                                          if (
                                            rateData?.sample_type &&
                                            finalBarcode
                                          ) {
                                            setSampleTypeBarcodeCache(
                                              (prev) => ({
                                                ...prev,
                                                [rateData.sample_type]:
                                                  finalBarcode,
                                              }),
                                            );
                                          }

                                          setTimeout(() => {
                                            setExpandedInvestigations(
                                              (prev) => ({
                                                ...prev,
                                                [newIndex]: true,
                                              }),
                                            );
                                          }, 100);
                                        } else {
                                          if (already) {
                                            alert(
                                              "Already Investigation Mapped !!",
                                            );
                                          }
                                        }
                                      }
                                    }

                                    if (paymentMode != "CASH") {
                                      setFieldValue("payment_mode_id", 1);
                                      setFieldValue(
                                        "paymentModechk",
                                        values.paymentModechk
                                          ? values.paymentModechk
                                          : paymentMode,
                                      );
                                      setFieldValue("amount", 0);
                                      setFieldValue("payment_mode", {
                                        value: "CASH",
                                        label: "CASH",
                                        payment_mode_id: 1,
                                      });
                                    } else {
                                      setFieldValue(
                                        "paymentModechk",
                                        values.paymentModechk
                                          ? values.paymentModechk
                                          : paymentMode,
                                      );
                                    }
                                  }}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3 col-12 mb-3">
                            <div className="card h-100">
                              <div className="card-header d-flex justify-content-between align-items-center">
                                <h6 className="mb-0 text-primary">
                                  Selected Investigations
                                </h6>
                                <span className="badge badge-primary">
                                  {values?.investigtion_details?.length || 0}
                                </span>
                              </div>

                              <div
                                className="card-body"
                                style={{
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                }}
                              >
                                {values?.investigtion_details?.length === 0 ? (
                                  <div className="text-center text-muted py-4">
                                    <p>No investigations selected</p>
                                  </div>
                                ) : (
                                  values?.investigtion_details.map(
                                    (field, index) => (
                                      <div
                                        key={index}
                                        className="investigation-item mb-2 p-2 border rounded"
                                      >
                                        <div className="d-flex justify-content-between align-items-center">
                                          <div className="flex-grow-1">
                                            <h6
                                              className="mb-0 investigation-name"
                                              title={field?.investigation_name}
                                            >
                                              {field?.investigation_name}
                                            </h6>
                                          </div>
                                          <div className="d-flex align-items-center">
                                            {field?.investigation_status_obj
                                              ?.status !== "APPROVED" && (
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                  setInvestigationIds(
                                                    (prev) => [
                                                      ...prev,
                                                      field.investigation_id,
                                                    ],
                                                  );

                                                  const updated =
                                                    values?.investigtion_details?.filter(
                                                      (_, i) => i !== index,
                                                    );

                                                  setFieldValue(
                                                    "investigtion_details",
                                                    updated,
                                                  );
                                                }}
                                                title="Remove Investigation"
                                              >
                                                <i className="fas fa-trash"></i>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ),
                                  )
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6 col-12 mb-3">
                            <div className="card h-100">
                              <div className="card-header">
                                <h6 className="mb-0 text-primary">
                                  Sample Details
                                </h6>
                              </div>
                              <div
                                className="card-body p-0"
                                style={{
                                  maxHeight: "300px",
                                  overflowY: "auto",
                                }}
                              >
                                {values?.investigtion_details?.length > 0 ? (
                                  <table className="table table-bordered table-sm table-hover mb-0">
                                    <thead className="table-light sticky-top">
                                      <tr>
                                        <th style={{ width: "10%" }}>#</th>
                                        <th style={{ width: "25%" }}>
                                          Barcode ID
                                        </th>
                                        <th style={{ width: "25%" }}>
                                          Type of Sample
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(() => {
                                        const groupedBySampleType = (
                                          values?.investigtion_details ?? []
                                        )
                                          .filter(
                                            (inv) => inv && inv.sample_type,
                                          )
                                          .reduce(
                                            (
                                              acc,
                                              investigation,
                                              originalIndex,
                                            ) => {
                                              const sampleType =
                                                investigation.sample_type;

                                              if (!acc[sampleType]) {
                                                acc[sampleType] = {
                                                  investigations: [],
                                                  firstIndex: originalIndex,
                                                };
                                              }

                                              acc[
                                                sampleType
                                              ].investigations.push({
                                                ...investigation,
                                                originalIndex,
                                              });

                                              return acc;
                                            },
                                            {},
                                          );

                                        const checkDuplicateBarcode = (
                                          currentValue,
                                          currentSampleType,
                                        ) => {
                                          const currentValStr = String(
                                            currentValue ?? "",
                                          ).trim();
                                          if (!currentValStr) return false;

                                          const allBarcodes = [];

                                          Object.entries(
                                            groupedBySampleType,
                                          ).forEach(([sampleType, data]) => {
                                            if (
                                              sampleType !== currentSampleType
                                            ) {
                                              const barcode =
                                                values.investigtion_details[
                                                  data.firstIndex
                                                ]?.barcode_id;
                                              if (barcode) {
                                                allBarcodes.push(
                                                  String(barcode).trim(),
                                                );
                                              }
                                            }
                                          });

                                          packageInvestigationData?.forEach(
                                            (inv) => {
                                              const invSampleType =
                                                inv?.sample_type_obj?.[0]
                                                  ?.sample_type;
                                              if (
                                                invSampleType !==
                                                currentSampleType
                                              ) {
                                                const barcode =
                                                  inv?.barcode_obj?.barcode_no;
                                                if (barcode) {
                                                  allBarcodes.push(
                                                    String(barcode).trim(),
                                                  );
                                                }
                                              }
                                            },
                                          );

                                          return allBarcodes.includes(
                                            currentValStr,
                                          );
                                        };

                                        return Object.entries(
                                          groupedBySampleType,
                                        ).map(
                                          ([sampleType, data], groupIndex) => {
                                            const currentBarcode =
                                              values.investigtion_details[
                                                data.firstIndex
                                              ]?.barcode_id || "";
                                            const isDuplicate =
                                              checkDuplicateBarcode(
                                                currentBarcode,
                                                sampleType,
                                              );
                                            return (
                                              <tr key={`group-${groupIndex}`}>
                                                <td>{groupIndex + 1}</td>
                                                <td>
                                                  <Field
                                                    name={`investigtion_details.${data.firstIndex}.barcode_id`}
                                                    type="text"
                                                    className={`form-control form-control-sm ${
                                                      isDuplicate
                                                        ? "is-invalid"
                                                        : ""
                                                    }`}
                                                    disabled={
                                                      !!(
                                                        appointment_id &&
                                                        values
                                                          ?.investigtion_details?.[
                                                          data.firstIndex
                                                        ]?.read_only
                                                      )
                                                    }
                                                    value={currentBarcode}
                                                    onChange={(e) => {
                                                      const value =
                                                        e.target.value
                                                          .replace(
                                                            /[^a-zA-Z0-9\-_/+]/g,
                                                            "",
                                                          )
                                                          .toUpperCase();

                                                      setFieldValue(
                                                        `investigtion_details.${data.firstIndex}.barcode_id`,
                                                        value,
                                                      );

                                                      data.investigations.forEach(
                                                        (investigation) => {
                                                          if (
                                                            investigation.originalIndex !==
                                                            data.firstIndex
                                                          ) {
                                                            setFieldValue(
                                                              `investigtion_details.${investigation.originalIndex}.barcode_id`,
                                                              value,
                                                            );
                                                          }
                                                        },
                                                      );

                                                      values.package_details?.forEach(
                                                        (pkg, pkgIdx) => {
                                                          pkg.package_investigations?.forEach(
                                                            (
                                                              investigation,
                                                              invIdx,
                                                            ) => {
                                                              const matched =
                                                                investigation.sample_type_obj?.find(
                                                                  (st) =>
                                                                    st.sample_type ===
                                                                    sampleType,
                                                                );
                                                              if (matched) {
                                                                setFieldValue(
                                                                  `package_details.${pkgIdx}.package_investigations.${invIdx}.barcode_obj.barcode_no`,
                                                                  value,
                                                                );
                                                              }
                                                            },
                                                          );
                                                        },
                                                      );

                                                      setPackageInvestigationData(
                                                        (prevData) => {
                                                          const updatedData = [
                                                            ...prevData,
                                                          ];

                                                          updatedData.forEach(
                                                            (inv, idx) => {
                                                              const invSampleType =
                                                                inv
                                                                  ?.sample_type_obj?.[0]
                                                                  ?.sample_type;
                                                              if (
                                                                invSampleType ===
                                                                sampleType
                                                              ) {
                                                                updatedData[
                                                                  idx
                                                                ] = {
                                                                  ...updatedData[
                                                                    idx
                                                                  ],
                                                                  barcode_obj: {
                                                                    ...updatedData[
                                                                      idx
                                                                    ]
                                                                      .barcode_obj,
                                                                    barcode_no:
                                                                      value,
                                                                  },
                                                                };
                                                              }
                                                            },
                                                          );

                                                          return updatedData;
                                                        },
                                                      );
                                                    }}
                                                  />
                                                  {isDuplicate &&
                                                    currentBarcode.trim() && (
                                                      <small className="text-danger mt-1 d-block">
                                                        <i className="fas fa-exclamation-triangle me-1"></i>
                                                        This barcode is already
                                                        used for another sample
                                                        type
                                                      </small>
                                                    )}
                                                </td>
                                                <td>
                                                  <span className="badge bg-secondary">
                                                    {sampleType}
                                                  </span>
                                                  <small className="text-muted d-block mt-1">
                                                    (
                                                    {data.investigations.length}{" "}
                                                    test
                                                    {data.investigations
                                                      .length > 1
                                                      ? "s"
                                                      : ""}
                                                    )
                                                  </small>
                                                </td>
                                              </tr>
                                            );
                                          },
                                        );
                                      })()}
                                    </tbody>
                                  </table>
                                ) : (
                                  <div className="text-center text-muted py-4">
                                    <p>No investigations selected</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <style jsx>{`
                          .card {
                            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                            border-radius: 12px;
                            overflow: hidden;
                          }

                          .card-header {
                            background-color: #f5f9ff;
                            border-bottom: 1px solid #e3e6f0;
                            padding: 12px 16px;
                          }

                          .card-header h6 {
                            font-size: 1rem;
                            color: #0d6efd;
                            font-weight: 600;
                          }

                          .card-body {
                            padding: 16px;
                          }

                          .badge-primary {
                            background-color: #0d6efd;
                            color: #fff;
                            font-size: 0.75rem;
                            padding: 4px 10px;
                            border-radius: 999px;
                          }

                          .investigation-name {
                            word-wrap: break-word;
                            white-space: normal;
                            overflow-wrap: break-word;
                            font-size: 0.95rem;
                            font-weight: 600;
                            color: #343a40;
                          }

                          .investigation-item {
                            transition: all 0.2s ease-in-out;
                            border: 1px solid #dee2e6;
                            border-radius: 8px;
                            background: #ffffff;
                          }

                          .investigation-item:hover {
                            background-color: #f1f5ff;
                            border-color: #0d6efd;
                          }

                          .detailed-investigation {
                            background: #f8f9fc;
                            border-radius: 10px;
                            padding: 16px;
                          }

                          .form-label {
                            font-size: 0.8rem;
                            color: #6c757d;
                            font-weight: 500;
                          }

                          .form-control-sm {
                            font-size: 0.875rem;
                            border-radius: 6px;
                          }

                          button.btn-sm {
                            font-size: 0.75rem;
                            padding: 4px 8px;
                          }

                          .text-primary {
                            color: #0d6efd !important;
                          }

                          @media (max-width: 768px) {
                            .card-body {
                              max-height: 300px !important;
                            }

                            .detailed-investigation {
                              padding: 12px;
                            }
                          }

                          @media (max-width: 768px) {
                            .investigation-item .d-flex {
                              flex-direction: column;
                              align-items: flex-start;
                            }

                            .investigation-item .d-flex > div:last-child {
                              margin-top: 0.5rem;
                              align-self: flex-end;
                            }
                          }
                        `}</style>
                      </>
                    )}
                  </FieldArray>
                </>

                <>
                  <div className="heading-form mt-3 text-primary d-flex align-items-center">
                    <span>Package Details</span>
                    <button
                      type="button"
                      className="btn btn-sm ms-2 d-flex align-items-center justify-content-center"
                      onClick={togglePackageDetails}
                      style={{
                        border: "1px solid #e3e6f0",
                        background: "#f8f9fa",
                        color: "#0d6efd",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        minWidth: "32px",
                        height: "32px",
                      }}
                    >
                      {showPackageDetails ? (
                        <i
                          className="fas fa-chevron-up"
                          title="Hide Package Details"
                        ></i>
                      ) : (
                        <i
                          className="fas fa-chevron-down"
                          title="Show Package Details"
                        ></i>
                      )}
                    </button>
                  </div>

                  {showPackageDetails && (
                    <FieldArray name="package_details">
                      {({ insert, remove, push }) => (
                        <>
                          <div className="row" style={{ minHeight: "150px" }}>
                            <div className="col-md-3 col-12 mb-3">
                              <div className="card h-100">
                                <div className="card-header">
                                  <h6 className="mb-0 text-primary">
                                    Select Package
                                  </h6>
                                </div>
                                <div className="card-body">
                                  <Select
                                    options={franchise_package_list_dd?.map(
                                      (item) => {
                                        return {
                                          value: item?.package_id,
                                          label: item?.package_name,
                                        };
                                      },
                                    )}
                                    value={
                                      values.package_name &&
                                      values.package_name.value
                                        ? values.package_name
                                        : null
                                    }
                                    name="package_name"
                                    isClearable
                                    menuIsOpen={packageMenuIsOpen}
                                    onMenuOpen={() =>
                                      setPackageMenuIsOpen(true)
                                    }
                                    onMenuClose={() => {
                                      return false;
                                    }}
                                    placeholder="Select Package Name"
                                    menuPortalTarget={null}
                                    menuPosition="static"
                                    menuPlacement="auto"
                                    components={{
                                      DropdownIndicator: (props) => {
                                        let touchStarted = false;

                                        const handleClick = (e) => {
                                          if (touchStarted) {
                                            touchStarted = false;
                                            return;
                                          }
                                          e.preventDefault();
                                          e.stopPropagation();
                                          setPackageMenuIsOpen(
                                            !packageMenuIsOpen,
                                          );
                                        };

                                        const handleTouchStart = (e) => {
                                          touchStarted = true;
                                          e.preventDefault();
                                          e.stopPropagation();
                                        };

                                        const handleTouchEnd = (e) => {
                                          if (touchStarted) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setPackageMenuIsOpen(
                                              !packageMenuIsOpen,
                                            );
                                            setTimeout(() => {
                                              touchStarted = false;
                                            }, 100);
                                          }
                                        };

                                        return (
                                          <div
                                            {...props.innerProps}
                                            onClick={handleClick}
                                            onTouchStart={handleTouchStart}
                                            onTouchEnd={handleTouchEnd}
                                            style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              touchAction: "manipulation",
                                              WebkitTouchCallout: "none",
                                              WebkitUserSelect: "none",
                                              userSelect: "none",
                                            }}
                                          >
                                            <svg
                                              height="20"
                                              width="20"
                                              viewBox="0 0 20 20"
                                              style={{
                                                transform: packageMenuIsOpen
                                                  ? "rotate(180deg)"
                                                  : "rotate(0deg)",
                                                transition: "transform 0.2s",
                                                pointerEvents: "none",
                                              }}
                                            >
                                              <path
                                                d="m4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                                                fill="currentColor"
                                              />
                                            </svg>
                                          </div>
                                        );
                                      },

                                      Option: (props) => {
                                        return (
                                          <div
                                            {...props.innerProps}
                                            onClick={(e) => {
                                              props.selectOption(props.data);
                                              setTimeout(
                                                () =>
                                                  setPackageMenuIsOpen(true),
                                                0,
                                              );
                                            }}
                                            style={{
                                              ...props.innerProps.style,
                                              backgroundColor: props.isFocused
                                                ? "#f0f0f0"
                                                : "white",
                                              cursor: "pointer",
                                              padding: "8px 12px",
                                            }}
                                          >
                                            {props.children}
                                          </div>
                                        );
                                      },
                                    }}
                                    styles={{
                                      menu: (base) => ({
                                        ...base,
                                        position: "static",
                                        zIndex: 9999,
                                        boxShadow:
                                          "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
                                      }),
                                      menuList: (base) => ({
                                        ...base,
                                        position: "static",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                      }),
                                      control: (base, state) => ({
                                        ...base,
                                        zIndex: 1,
                                        boxShadow: state.isFocused
                                          ? base.boxShadow
                                          : base.boxShadow,
                                      }),
                                      valueContainer: (base) => ({
                                        ...base,
                                        cursor: "text",
                                      }),
                                    }}
                                    onChange={async (val) => {
                                      setFieldValue("package_name", val);
                                      setFieldValue("package_id", val?.value);

                                      setTimeout(
                                        () => setPackageMenuIsOpen(true),
                                        0,
                                      );

                                      let franchiseIdToUse =
                                        values?.franchise_id ||
                                        _token?.franchise_id ||
                                        franchise_id;
                                      if (!values?.franchise_id) {
                                        const storedFranchiseId =
                                          localStorage.getItem(
                                            "new_registration_franchise_id",
                                          );
                                        if (storedFranchiseId) {
                                          franchiseIdToUse = storedFranchiseId;
                                        }
                                      }

                                      if (val) {
                                        const isDuplicate =
                                          values.package_details?.some(
                                            (pkg) =>
                                              pkg.package_id === val.value &&
                                              !pkg.isDisabled &&
                                              !pkg.removed,
                                          );

                                        if (isDuplicate) {
                                          alert(
                                            "This package has already been added!",
                                          );
                                          return;
                                        }

                                        if (franchiseIdToUse) {
                                          const { data } =
                                            await axiosInstance.get(
                                              `LIS/master/list/franchise_package_rate/${
                                                franchiseIdToUse
                                                  ? franchiseIdToUse
                                                  : _token?.franchise_id
                                              }/${
                                                val?.value
                                              }?appointment_booking_id=${
                                                appointmentBookingData?.id ||
                                                appointmentBookingId
                                              }`,
                                            );

                                          const already =
                                            data[0]?.package_investigations?.filter(
                                              (item) => {
                                                const existsInPackageData =
                                                  packageInvestigationData?.some(
                                                    (packageInv) =>
                                                      packageInv.investigation_id ==
                                                      item.investigation_id,
                                                  );

                                                const existsInInvestigationDetails =
                                                  values.investigtion_details?.some(
                                                    (invDetail) =>
                                                      invDetail.investigation_id ==
                                                      item.investigation_id,
                                                  );

                                                return (
                                                  existsInPackageData ||
                                                  existsInInvestigationDetails
                                                );
                                              },
                                            );

                                          console.log(
                                            "**********************already****************",
                                            already,
                                          );

                                          const rateData = data[0];

                                          console.log(
                                            "**********************rateData****************",
                                            rateData,
                                          );

                                          const currentFranchise =
                                            franchiseOptions?.find(
                                              (franchise) =>
                                                franchise.franchise_id ==
                                                franchiseIdToUse,
                                            );

                                          const shouldIncludeBarcode =
                                            currentFranchise?.allow_preprint_barcode !==
                                            true;

                                          if (
                                            rateData?.rate === 0 ||
                                            rateData?.mrp_rate === 0
                                          ) {
                                            setShowRateNotConfiguredModal(true);
                                          } else if (already?.length == 0) {
                                            const processedInvestigations =
                                              rateData?.package_investigations?.map(
                                                (investigation) => {
                                                  const processedInvestigation =
                                                    { ...investigation };

                                                  if (!shouldIncludeBarcode) {
                                                    processedInvestigation.barcode_obj =
                                                      {
                                                        ...processedInvestigation.barcode_obj,
                                                        barcode_no: "",
                                                      };
                                                  }

                                                  return processedInvestigation;
                                                },
                                              ) || [];

                                            push({
                                              package_id: val?.value,
                                              package_name: val?.label,
                                              mrp: rateData?.mrp_rate,
                                              rate: rateData?.rate,
                                              discount: 0,
                                              is_urgent: "0",
                                              package_investigations:
                                                processedInvestigations,
                                              read_only: false,
                                            });

                                            setPackageInvestigationData(
                                              (prev) => [
                                                ...prev,
                                                ...processedInvestigations,
                                              ],
                                            );
                                          } else {
                                            alert(
                                              "Already Investigation Available !!",
                                            );
                                          }
                                        }
                                      }

                                      if (paymentMode != "CASH") {
                                        setFieldValue("payment_mode_id", 1);
                                        setFieldValue(
                                          "paymentModechk",
                                          values.paymentModechk
                                            ? values.paymentModechk
                                            : paymentMode,
                                        );
                                        setFieldValue("amount", 0);
                                        setFieldValue("payment_mode", {
                                          value: "CASH",
                                          label: "CASH",
                                          payment_mode_id: 1,
                                        });
                                      } else {
                                        setFieldValue(
                                          "paymentModechk",
                                          values.paymentModechk
                                            ? values.paymentModechk
                                            : paymentMode,
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className="col-md-3 col-12 mb-3">
                              <div className="card h-100">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                  <h6 className="mb-0 text-primary">
                                    Selected Packages
                                  </h6>
                                  <span className="badge badge-primary">
                                    {values?.package_details?.length || 0}
                                  </span>
                                </div>

                                <div
                                  className="card-body"
                                  style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {values?.package_details?.length === 0 ? (
                                    <div className="text-center text-muted py-4">
                                      <p>No packages selected</p>
                                    </div>
                                  ) : (
                                    values?.package_details.map(
                                      (field, index) => (
                                        <div
                                          key={index}
                                          className="package-item mb-2 p-2 border rounded"
                                        >
                                          <div className="d-flex justify-content-between align-items-center">
                                            <div className="flex-grow-1">
                                              <h6
                                                className="mb-0 package-name"
                                                title={field?.package_name}
                                              >
                                                {field?.package_name}
                                              </h6>
                                              <small className="text-muted">
                                                {field?.package_investigations
                                                  ?.length || 0}{" "}
                                                investigations
                                              </small>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-outline-info"
                                                onClick={() => {
                                                  const updatedPackageInvestigations =
                                                    JSON.parse(
                                                      JSON.stringify(
                                                        field?.package_investigations ||
                                                          [],
                                                      ),
                                                    );
                                                  openPackageView(
                                                    updatedPackageInvestigations,
                                                  );
                                                }}
                                                title="View Package Details"
                                              >
                                                <i className="fas fa-eye"></i>
                                              </button>
                                              {!field?.package_investigations?.some(
                                                (inv) =>
                                                  inv?.investigation_status_obj
                                                    ?.status === "APPROVED",
                                              ) && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-outline-danger"
                                                  onClick={() => {
                                                    setPackagesIds((prev) => [
                                                      ...prev,
                                                      field.package_id,
                                                    ]);

                                                    const removedPackageInvestigations =
                                                      field.package_investigations ||
                                                      [];
                                                    const removedInvestigationIds =
                                                      removedPackageInvestigations.map(
                                                        (inv) =>
                                                          inv.investigation_id,
                                                      );

                                                    const updatedPackageDetails =
                                                      values.package_details.filter(
                                                        (_, i) => i !== index,
                                                      );
                                                    setFieldValue(
                                                      "package_details",
                                                      updatedPackageDetails,
                                                    );

                                                    setPackageInvestigationData(
                                                      (prevData) => {
                                                        return prevData.filter(
                                                          (investigation) =>
                                                            !removedInvestigationIds.includes(
                                                              investigation.investigation_id,
                                                            ),
                                                        );
                                                      },
                                                    );

                                                    // const updatedInvestigationDetails =
                                                    //   values.investigtion_details?.filter(
                                                    //     (inv, invIndex) => {
                                                    //       const correspondingPackageInv =
                                                    //         packageInvestigationData[
                                                    //           invIndex
                                                    //         ];
                                                    //       return (
                                                    //         correspondingPackageInv &&
                                                    //         !removedInvestigationIds.includes(
                                                    //           correspondingPackageInv.investigation_id
                                                    //         )
                                                    //       );
                                                    //     }
                                                    //   );

                                                    // if (
                                                    //   updatedInvestigationDetails
                                                    // ) {
                                                    //   setFieldValue(
                                                    //     "investigtion_details",
                                                    //     updatedInvestigationDetails
                                                    //   );
                                                    // }
                                                  }}
                                                  title="Remove Package"
                                                >
                                                  <i className="fas fa-trash"></i>
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ),
                                    )
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6 col-12 mb-3">
                              <div className="card h-100">
                                <div className="card-header">
                                  <h6 className="mb-0 text-primary">
                                    Package Configuration
                                  </h6>
                                </div>
                                <div
                                  className="card-body p-0"
                                  style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {packageInvestigationData?.length > 0 ? (
                                    <table className="table table-bordered table-sm table-hover mb-0">
                                      <thead className="table-light sticky-top">
                                        <tr>
                                          <th style={{ width: "10%" }}>#</th>
                                          <th style={{ width: "25%" }}>
                                            Barcode No
                                          </th>
                                          <th style={{ width: "25%" }}>
                                            Type of Sample
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(() => {
                                          const allInvestigations =
                                            packageInvestigationData.map(
                                              (investigation, index) => ({
                                                ...investigation,
                                                originalIndex: index,
                                                sampleType:
                                                  investigation
                                                    ?.sample_type_obj?.[0]
                                                    ?.sample_type || "N/A",
                                                isDisabled:
                                                  investigation?.isDisabled ||
                                                  false,
                                              }),
                                            );

                                          const groupedBySampleType =
                                            allInvestigations.reduce(
                                              (acc, investigation) => {
                                                const sampleType =
                                                  investigation.sampleType;
                                                if (!acc[sampleType]) {
                                                  acc[sampleType] = {
                                                    investigations: [],
                                                    firstInvestigation:
                                                      investigation,
                                                    firstIndex:
                                                      investigation.originalIndex,
                                                  };
                                                }
                                                acc[
                                                  sampleType
                                                ].investigations.push(
                                                  investigation,
                                                );
                                                return acc;
                                              },
                                              {},
                                            );

                                          const checkDuplicateBarcode = (
                                            currentValue,
                                            currentSampleType,
                                          ) => {
                                            if (
                                              !currentValue ||
                                              !String(currentValue)?.trim()
                                            )
                                              return false;

                                            const allBarcodes = [];

                                            Object.entries(
                                              groupedBySampleType,
                                            ).forEach(([sampleType, data]) => {
                                              if (
                                                sampleType !== currentSampleType
                                              ) {
                                                const barcode =
                                                  packageInvestigationData[
                                                    data.firstIndex
                                                  ]?.barcode_obj?.barcode_no;
                                                if (
                                                  barcode &&
                                                  String(barcode)?.trim()
                                                ) {
                                                  allBarcodes.push(
                                                    String(barcode)?.trim(),
                                                  );
                                                }
                                              }
                                            });

                                            values.investigtion_details?.forEach(
                                              (inv) => {
                                                if (
                                                  inv.sample_type !==
                                                    currentSampleType &&
                                                  inv?.barcode_id &&
                                                  String(
                                                    inv?.barcode_id,
                                                  )?.trim()
                                                ) {
                                                  allBarcodes.push(
                                                    String(
                                                      inv?.barcode_id,
                                                    )?.trim(),
                                                  );
                                                }
                                              },
                                            );

                                            return allBarcodes.includes(
                                              String(currentValue)?.trim(),
                                            );
                                          };

                                          return Object.entries(
                                            groupedBySampleType,
                                          ).map(
                                            (
                                              [sampleType, data],
                                              groupIndex,
                                            ) => {
                                              const currentBarcode =
                                                packageInvestigationData[
                                                  data.firstIndex
                                                ]?.barcode_obj?.barcode_no ||
                                                "";
                                              const isDuplicate =
                                                checkDuplicateBarcode(
                                                  currentBarcode,
                                                  sampleType,
                                                );

                                              return (
                                                <tr
                                                  key={`group-${groupIndex}`}
                                                  style={{
                                                    opacity: data
                                                      .firstInvestigation
                                                      .isDisabled
                                                      ? 0.5
                                                      : 1,
                                                  }}
                                                >
                                                  <td>{groupIndex + 1}</td>
                                                  <td>
                                                    <div>
                                                      <input
                                                        type="text"
                                                        className={`form-control form-control-sm ${
                                                          isDuplicate
                                                            ? "is-invalid"
                                                            : ""
                                                        }`}
                                                        value={currentBarcode}
                                                        disabled={
                                                          !!(
                                                            appointment_id &&
                                                            data.investigations.every(
                                                              (inv) =>
                                                                packageInvestigationData[
                                                                  inv
                                                                    .originalIndex
                                                                ]?.read_only ===
                                                                true,
                                                            )
                                                          )
                                                        }
                                                        onChange={(e) => {
                                                          const value =
                                                            e.target.value
                                                              .replace(
                                                                /[^a-zA-Z0-9\-_/+]/g,
                                                                "",
                                                              )
                                                              .toUpperCase();

                                                          setPackageInvestigationData(
                                                            (prevData) => {
                                                              const updatedData =
                                                                [...prevData];

                                                              data.investigations.forEach(
                                                                (inv) => {
                                                                  if (
                                                                    updatedData[
                                                                      inv
                                                                        .originalIndex
                                                                    ]
                                                                  ) {
                                                                    updatedData[
                                                                      inv.originalIndex
                                                                    ] = {
                                                                      ...updatedData[
                                                                        inv
                                                                          .originalIndex
                                                                      ],
                                                                      barcode_obj:
                                                                        {
                                                                          ...updatedData[
                                                                            inv
                                                                              .originalIndex
                                                                          ]
                                                                            .barcode_obj,
                                                                          barcode_no:
                                                                            value,
                                                                        },
                                                                    };
                                                                  }
                                                                },
                                                              );

                                                              return updatedData;
                                                            },
                                                          );

                                                          values.package_details?.forEach(
                                                            (pkg, pkgIdx) => {
                                                              pkg.package_investigations?.forEach(
                                                                (
                                                                  investigation,
                                                                  invIdx,
                                                                ) => {
                                                                  const matched =
                                                                    investigation.sample_type_obj?.find(
                                                                      (st) =>
                                                                        st.sample_type ===
                                                                        sampleType,
                                                                    );
                                                                  if (matched) {
                                                                    setFieldValue(
                                                                      `package_details.${pkgIdx}.package_investigations.${invIdx}.barcode_obj.barcode_no`,
                                                                      value,
                                                                    );
                                                                  }
                                                                },
                                                              );
                                                            },
                                                          );

                                                          values.investigtion_details?.forEach(
                                                            (
                                                              investigation,
                                                              invIdx,
                                                            ) => {
                                                              if (
                                                                investigation.sample_type ===
                                                                sampleType
                                                              ) {
                                                                setFieldValue(
                                                                  `investigtion_details.${invIdx}.barcode_id`,
                                                                  value,
                                                                );
                                                              }
                                                            },
                                                          );
                                                        }}
                                                      />
                                                      {isDuplicate &&
                                                        currentBarcode.trim() && (
                                                          <small className="text-danger mt-1 d-block">
                                                            <i className="fas fa-exclamation-triangle me-1"></i>
                                                            This barcode is
                                                            already used for
                                                            another sample type
                                                          </small>
                                                        )}
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <span className="badge bg-secondary">
                                                      {sampleType}
                                                    </span>
                                                    <small className="text-muted d-block mt-1">
                                                      (
                                                      {
                                                        data.investigations
                                                          .length
                                                      }{" "}
                                                      test
                                                      {data.investigations
                                                        .length > 1
                                                        ? "s"
                                                        : ""}
                                                      )
                                                    </small>
                                                  </td>
                                                </tr>
                                              );
                                            },
                                          );
                                        })()}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <div className="text-center text-muted py-4">
                                      <i className="fas fa-box-open fa-2x mb-2 text-muted"></i>
                                      <p className="mb-0">
                                        No packages selected
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <style jsx>{`
                            .card {
                              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                              border-radius: 12px;
                              overflow: hidden;
                            }

                            .card-header {
                              background-color: #f5f9ff;
                              border-bottom: 1px solid #e3e6f0;
                              padding: 12px 16px;
                            }

                            .card-header h6 {
                              font-size: 1rem;
                              color: #0d6efd;
                              font-weight: 600;
                            }

                            .card-body {
                              padding: 16px;
                            }

                            .badge-primary {
                              background-color: #0d6efd;
                              color: #fff;
                              font-size: 0.75rem;
                              padding: 4px 10px;
                              border-radius: 999px;
                            }

                            .package-name {
                              word-wrap: break-word;
                              white-space: normal;
                              overflow-wrap: break-word;
                              font-size: 0.95rem;
                              font-weight: 600;
                              color: #343a40;
                            }

                            .package-item {
                              transition: all 0.2s ease-in-out;
                              border: 1px solid #dee2e6;
                              border-radius: 8px;
                              background: #ffffff;
                            }

                            .package-item:hover {
                              background-color: #f1f5ff;
                              border-color: #0d6efd;
                            }

                            .package-config-item {
                              background: #f8f9fc;
                              border-radius: 10px;
                              border: 1px solid #e3e6f0;
                            }

                            .form-label {
                              font-size: 0.8rem;
                              color: #6c757d;
                              font-weight: 500;
                              margin-bottom: 4px;
                            }

                            .form-control-sm {
                              font-size: 0.875rem;
                              border-radius: 6px;
                            }

                            button.btn-sm {
                              font-size: 0.75rem;
                              padding: 4px 8px;
                            }

                            .text-primary {
                              color: #0d6efd !important;
                            }

                            @media (max-width: 768px) {
                              .card-body {
                                max-height: 300px !important;
                              }

                              .package-config-item {
                                padding: 12px;
                              }
                            }

                            @media (max-width: 768px) {
                              .package-item .d-flex {
                                flex-direction: column;
                                align-items: flex-start;
                              }

                              .package-item .d-flex > div:last-child {
                                margin-top: 0.5rem;
                                align-self: flex-end;
                              }
                            }
                          `}</style>
                        </>
                      )}
                    </FieldArray>
                  )}
                </>

                <button
                  type="submit"
                  className="btn btn-primary mt-4"
                  ref={submitButtonRef}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Adding..." : "Add"}
                </button>
                {new_registration && new_registration?.patient_id && (
                  <>
                    <Link to={receptUrl} className="acc-link">
                      {" "}
                      <button
                        className="btn btn-primary mt-4"
                        style={{ marginLeft: "20px" }}
                      >
                        Receipt
                      </button>
                    </Link>
                    <p
                      className="pt-3"
                      style={{
                        paddingLeft: "3px",
                        color: "black",
                        fontWeight: "bolder",
                      }}
                    >
                      Your Appoinment ID is :{new_registration?.appointment_id}
                    </p>
                  </>
                )}

                {/* {investigationval > 0 && (
                  <p className="text-danger pt-3">
                    Investigation Mrp Should be greater than 0 !.
                  </p>
                )} */}
              </Form>
            </FormikProvider>
          </>
        </div>
      </div>
      <RateNotConfiguredModal
        show={showRateNotConfiguredModal}
        onHide={() => setShowRateNotConfiguredModal(false)}
      />
    </div>
  );
};

export default RegistrationFormFormat;
